<template>
  <svg
    id="Ebene_1"
    data-name="Ebene 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 302.27 286.25"
  >
    <g id="Generatives_Objekt" data-name="Generatives Objekt">
      <g>
        <path
          class="cls-56"
          d="M142.58,64.09c1.54,6.64,4.75,3.78,7.38-.36-1.41,5.03,8.96,18.63,13.14,18.72v.36c-.56.7-1.17,1.53-1.8,2.16-11.54,11.57-11.69,19.67-1.8,33.31,1.67,2.3,8.91,8.42,9.36,9.72,1.7,4.93-1.91,9.33-1.08,11.88.47,1.43,8.1,8.35,9.72,9.54-19.19-2.82-37.35-17.07-43.93-35.47-3.44-9.62-3.33-20.44-7.92-29.7,3.7-.59,5.57-1.02,4.32-5.04l.72-.36c1.69,1.5,5.85.74,7.2-1.08.02-.02.14.12.36-.36,8.76.49,5.49-4.91,4.32-9.72-.84-3.45-1.07-6.32-2.88-9.72,1.14,1.91,2.45,3.88,2.88,6.12Z"
        />

        <path
          class="cls-88"
          d="M123.86,83.89c.87-.13,1.23.45,1.8.36,4.59,9.26,4.48,20.08,7.92,29.7,6.57,18.4,24.74,32.64,43.93,35.47.34.25.73.49,1.08.72,2.47,1.63,5.87,4.98,7.92.72.63-1.3,1.36-6.96,1.44-8.64l18.36,27.54c4.5,5.01,12.35,7.9,16.2,13.14.53.73,1.96,2.32,1.62,3.24-6.6-3.62-13.52-8.86-20.34-11.88-6-2.66-12.56-3.59-18-7.56-.77-.56-1.39-2.45-2.88-2.16,1.35-1.91,1.91-4.44-1.44-3.6-1.27-1.86-4.51-2.19-6.48-3.24.61-.56,1.08-1.49,1.8-1.98-.54-3.62-6.26,2.21-6.84,1.08l1.26-1.26c-2.11-.03-3.73-1.61-5.94-1.08-2.85-2.57-6.98-3.75-10.26-5.76-25.13-15.43-22.84-28.78-28.98-54.19-.45-1.84-3.59-8.86-3.6-9.36-.03-1.39.48-1.12,1.44-1.26Z"
        />

        <path
          class="cls-46"
          d="M216.4,164.19c.09.05.27-.05.36,0,.33.18,3.35,5.56,3.96,6.48,6.45,9.77,12.69,19.71,19.08,29.52-.41.1-1.01.73-1.44.54-.68-.31-7.44-12.59-8.28-9l13.86,22.14c-3.27-4.15-6.76-8.18-9.9-12.42-4.41-5.94-6.68-13.57-14.58-15.66,4.07,9.68,12.45,19.39,20.16,26.64.71.67,5.54,2.96,2.52,3.96-2.11.7-7.5-4.28-9.18-5.94-1.99-1.96-3.54-5.3-6.12-6.3-7.75-9.93-14.12-20.88-23.04-29.88,6.82,3.02,13.74,8.26,20.34,11.88.34-.92-1.09-2.51-1.62-3.24l2.16.54-11.52-19.98c1.13.57,3.08.63,3.24.72Z"
        />

        <path
          class="cls-46"
          d="M239.8,200.19c1.65,2.53,3.4,5.01,5.04,7.56,1.48,2.3,2.83,4.75,4.32,7.02.21.32,1.51,2.31,2.16,1.62.27.68,1.68,2.84,1.44,3.42-2.42,2.61-7.59-5.13-8.1-5.22-.4-.07-1.1,2.29-2.88,2.52-5.38.7-12.09-9.31-14.94-12.96,2.58,1,4.13,4.34,6.12,6.3,1.68,1.66,7.07,6.64,9.18,5.94,3.02-1-1.81-3.29-2.52-3.96-7.71-7.26-16.1-16.97-20.16-26.64,7.9,2.1,10.18,9.72,14.58,15.66,3.15,4.24,6.63,8.27,9.9,12.42l-13.86-22.14c.84-3.59,7.6,8.7,8.28,9,.43.19,1.03-.44,1.44-.54Z"
        />

        <path
          class="cls-81"
          d="M206.67,121.34c4.98,9.51,11.4,18.35,16.92,27.54l-4.32-1.62c-1.08-1.66-3.33-3.76-4.86-5.04-1.13-.95-2.86-1.02-3.78-1.8-.08-.07.18-.7-.18-1.08-.06-.06-1.33-.09-1.62-.54-1.23-1.88-2.47-6.8.36-7.92-2.1,1.79-2.69.52-3.06.54-.56.03-.15,2.21-1.44,1.8-1.59-3.29-5.4-7.61-6.66-10.8-.31-.78-.43-1.67-.36-2.52,3.37.43,6.33-.51,9,1.44Z"
        />

        <path
          class="cls-58"
          d="M235.12,47.53c-.03,1.13-1.17,1.51-1.8,2.16-6.13,2.34-11.76,5.84-17.64,8.64-2.85,1.36-5.77,2.64-8.64,3.96-8.89,4.07-18.08,7.55-27,11.52-5.47,2.44-9.64,4.94-14.76,7.56.05-.74.95-1.65,1.44-2.16.74-.77,2.4-2.29,3.24-2.88.78-.55,1.7-.86,2.52-1.44,1.98-1.39,3.58-1.29,5.76-3.24,4.09-.78,7.76-3.05,11.52-4.68,6.51-2.83,12.95-5.78,19.44-8.64,8.62-3.8,16.96-7.84,25.92-10.8Z"
        />

        <path
          class="cls-22"
          d="M251.32,216.4c-.65.69-1.95-1.3-2.16-1.62-1.49-2.27-2.84-4.72-4.32-7.02-2.45-6.53-6.18-13.28-9.72-19.44.53-.68.26-.95,0-1.62-2.95-7.68-9.06-16.07-11.88-23.94-.98-2.73-1.28-4.77-1.8-7.56-.18-.98-.83-2.6-.36-3.6,10.19,18.37,22.51,45.21,30.24,64.81Z"
        />

        <path
          class="cls-54"
          d="M198.39,113.06c1.61.31,3.41.61,5.04.36.11,2.77,1.97,5.5,3.24,7.92-2.67-1.95-5.63-1.01-9-1.44-2.82-.36-4.64-1.1-6.84-2.88-1.3-1.05-2.77-2.25-3.24-3.96,2.17-4.49-.59-5.68-1.44-9-.1-.38-.52-.6-.36-1.08,4.52,4.28,5.76,8.75,12.6,10.08Z"
        />

        <path
          class="cls-26"
          d="M210.63,140.42c.92.78,2.65.86,3.78,1.8,1.53,1.28,3.78,3.38,4.86,5.04.35.54,1.2,3.23,1.8,4.32-.47,1,.18,2.62.36,3.6-1.32-2.17-2.24-3.02-4.68-3.96-1.11-.43-2.3-.69-3.96-.36-.97-2.99-2.8-6.19-3.06-9.36-.07-.87-.04-1.09.9-1.08Z"
        />

        <path
          class="cls-74"
          d="M162.39,105.86c.37,1.31-.66,3.34.72,4.32-.17.86-.6,1.66-.36,2.7,1.89-2.23,3.07-5.62,4.32-8.46,2.45,1.9,3.35,5.83,5.4,8.1,5.66,6.26,11.01,3.25,13.5-3.78.88,3.2-1.77,5.04-3.42,7.2-.13-.03-2.29.49-2.52.9-.08.45,4.59,3.47.36,2.34-.39-.19-6.23-3.23-6.12-1.98,3.16,2.17,5.78,10.14,8.82,11.7,1.77.91,3.35.39,4.14.72.06.02,1.03.68,1.08.72.27.24,2.07,4.01,2.52,4.5.82.88,4.59,4.56,5.4,5.22.93.76,1.26,1.12,2.52,1.44.03.79,2.41,5.01,2.7,5.04l1.26-1.08c-.49,1.79-.78,2.76,1.44,3.24,2.63,3.96,5.81,8.56,9.18,11.88.11.11.81-.09.9,0,.9.89,2.22,2.2,2.16,3.6-.16-.09-2.11-.15-3.24-.72-11.36-5.71-18.26-13.51-25.56-23.58.1.87.4,1.39.36,2.34-.08,1.68-.81,7.34-1.44,8.64l-7.92-.72c-.35-.23-.74-.47-1.08-.72-1.63-1.19-9.26-8.12-9.72-9.54-.83-2.55,2.78-6.95,1.08-11.88-.45-1.3-7.7-7.42-9.36-9.72-9.89-13.63-9.74-21.73,1.8-33.31-1.46,5.72-2.01,12.73-.72,18.54.05.24,1.23.34,1.8,2.34Z"
        />

        <path
          class="cls-58"
          d="M187.59,74.53c-2.47,1.44-5.09,2.57-7.56,3.96s-9.11,4.08-10.44,6.66c-1.2,2.32-2.02,10.75-2.88,14.04-.96,3.65-2.84,7.24-3.6,10.98-1.38-.98-.35-3.01-.72-4.32l.72-23.04v-.36c1.38.03,1.24-.61,2.16-1.08,5.13-2.62,9.29-5.12,14.76-7.56,2.57.76,5.3-1.74,7.56.72Z"
        />

        <path
          class="cls-35"
          d="M162.39,105.86c-.57-2-1.75-2.1-1.8-2.34-1.29-5.81-.74-12.82.72-18.54.63-.63,1.24-1.46,1.8-2.16l-.72,23.04Z"
        />

        <path
          class="cls-26"
          d="M229.36,53.65c-.73,1.24-1.52,2.29-2.16,3.6-.16.34-.59.68,0,.72-.17.09-1.25.9-1.44,1.08-6.95-1.42-13.99,5.48-19.8,8.82l2.52.54c-.36.06-4.57.3-2.7,1.44,2.54,1.54,8.64-.49,11.34,1.44-.03.05-.06.78-.36,1.08-.12,0-.24,0-.36,0-2.68-.08-14.51-2.5-13.14,1.8l11.34.36c-.75.98-1.35,2.28-2.16,3.24-.12,0-.24,0-.36,0-3.25-.24-11.47-3.39-11.16,1.98l8.64.9c-.93,1.06-1.84,2.48-2.88,3.6-7.76-2.76-17.84-1.5-3.96,3.6-.04.04-.32.69-.36.72-.64.59-1.07,1.22-1.8,1.8-.56.45-1.88-.12-1.44,1.8h-.36c-.64-2.75-6.23-2.5-8.28-2.16,1.15-1.59,2.11-3.6,1.8-5.58-.28-1.79-2.91-3.45-3.24-4.14-.13-.27-.63-2.71-.72-3.24-.06-.37.33-1.69-.36-2.52,6.46-3.77,12.91-8,19.08-12.24,2.87-1.32,5.79-2.6,8.64-3.96,1.21-.51,1.53.73,1.62.72.66-.04,11.17-4.82,12.06-5.4Z"
        />

        <path
          class="cls-60"
          d="M233.32,49.69c-.63.65-1.53,2-2.16,2.52-.43.36-1.36,1.38-1.44,1.44s-.28-.05-.36,0c-.9.59-11.4,5.36-12.06,5.4-.09,0-.41-1.23-1.62-.72,5.89-2.81,11.52-6.3,17.64-8.64Z"
        />

        <path
          class="cls-68"
          d="M213.16,163.47l11.52,19.98-2.16-.54c-3.85-5.24-11.7-8.13-16.2-13.14l-18.36-27.54c.04-.95-.26-1.47-.36-2.34,7.3,10.07,14.21,17.87,25.56,23.58Z"
        />

        <path class="cls-12" d="M186.51,150.86c-2.05,4.26-5.45.91-7.92-.72l7.92.72Z" />

        <path
          class="cls-18"
          d="M212.07,77.77c-.34,1.41-1.74,1.99-2.52,2.88l-8.64-.9c-.3-5.37,7.91-2.23,11.16-1.98Z"
        />

        <path
          class="cls-18"
          d="M206.67,84.25c-.84.91-1.64,2.01-2.52,2.88-.06.06-.99.3-1.44.72-13.88-5.1-3.8-6.36,3.96-3.6Z"
        />

        <path
          class="cls-77"
          d="M182.91,116.3c1.27.63,1.04,2.41,3.6,2.88,3.38.62,6.49,1.16,9.9,2.16.47.14,1.13.89,1.62,1.08,1.26,3.19,5.07,7.52,6.66,10.8,1.29.41.88-1.77,1.44-1.8.37-.02.96,1.25,3.06-.54-2.83,1.12-1.59,6.04-.36,7.92.29.45,1.56.48,1.62.54.36.38.1,1.01.18,1.08-.94-.01-.97.21-.9,1.08.26,3.17,2.09,6.37,3.06,9.36.33,1.03.85,1.52,1.08,2.16.96,2.68,1.11,8.64,3.6,10.08l-.72,1.08c-.09-.05-.27.05-.36,0,.06-1.4-1.26-2.71-2.16-3.6l-4.32-12.06c-1.09-1.27-3.6.65-5.76.18s-1.93-1.45-1.44-3.24c.8-2.96,3.19-2.64,4.14-5.04-2.4,1.77-5.22,1.81-8.1,1.08-1.27-.32-1.59-.68-2.52-1.44,3.74-.67,3.28-4.81,4.68-7.38-3.38,1.18-5.39,5.18-9.36,2.16,4.89-1.34,3.01-6.21,5.4-9.72-1.03,2.37-4.23,1.83-5.22,2.34-.75.39-1.76,2.63-3.42,2.88-.05-.04-1.02-.7-1.08-.72-.21-1.41-1.47-7.82-2.16-8.46-1.04-.96-2.88-.44-3.78-.9-.95-.49-.84-1.05-.9-1.08,4.23,1.13-.44-1.89-.36-2.34.23-.41,2.39-.93,2.52-.9.49.1.34.35.36.36Z"
        />

        <path
          class="cls-27"
          d="M235.12,188.31c3.55,6.17,7.27,12.91,9.72,19.44-1.64-2.55-3.39-5.03-5.04-7.56-6.39-9.81-12.64-19.75-19.08-29.52,1.31-.49,2.08-1.94,1.8-3.24,2.05,5.84,9.28,15.1,12.6,20.88Z"
        />

        <path
          class="cls-50"
          d="M221.8,163.47c-.04.78.45,3.2.72,3.96.28,1.3-.49,2.75-1.8,3.24-.61-.93-3.63-6.3-3.96-6.48l.72-1.08c1.46.84,2.74.62,4.32.36Z"
        />

        <path
          class="cls-26"
          d="M225.76,59.05c-.88.84-4.85,7.26-6.12,9-3.45-.38-7.75-.19-11.16.36l-2.52-.54c5.81-3.34,12.85-10.24,19.8-8.82Z"
        />

        <path
          class="cls-18"
          d="M219.64,68.05c-.82,1.13-1.68,2.15-2.52,3.24-2.7-1.93-8.8.1-11.34-1.44-1.87-1.14,2.34-1.38,2.7-1.44,3.41-.55,7.71-.74,11.16-.36Z"
        />

        <path
          class="cls-10"
          d="M190.83,117.02c2.2,1.78,4.02,2.52,6.84,2.88-.07.85.05,1.74.36,2.52-.49-.19-1.15-.94-1.62-1.08-3.41-1-6.53-1.54-9.9-2.16.49-.79,3.01-1.91,4.32-2.16Z"
        />

        <path
          class="cls-18"
          d="M216.4,72.37c-.25.89-1.39,1.62-1.8,2.16l-11.34-.36c-1.37-4.3,10.46-1.88,13.14-1.8Z"
        />

        <path
          class="cls-36"
          d="M207.03,62.29c-6.17,4.25-12.62,8.47-19.08,12.24-.09.05-.27-.05-.36,0-2.26-2.46-5,.04-7.56-.72,8.92-3.98,18.11-7.45,27-11.52Z"
        />

        <path
          class="cls-10"
          d="M221.44,155.19c.53,2.79.82,4.83,1.8,7.56-1.2-.53-1.33-1.22-1.44.72-1.58.26-2.86.48-4.32-.36-2.49-1.44-2.64-7.4-3.6-10.08l2.88-1.8c2.45.94,3.36,1.79,4.68,3.96Z"
        />

        <path
          class="cls-27"
          d="M223.24,162.75c2.82,7.88,8.94,16.26,11.88,23.94.26.67.53.94,0,1.62-3.32-5.78-10.56-15.04-12.6-20.88-.27-.76-.76-3.18-.72-3.96.11-1.94.24-1.25,1.44-.72Z"
        />

        <path
          class="cls-8"
          d="M190.47,90.01c2.05-.34,7.65-.59,8.28,2.16l-3.96,3.24c-.12-.13-2.46-1.99-2.88-1.98.66,1.05,1.43,2.06,2.16,3.06-1.61.96-2.99,2.84-4.32,3.96-.78.65-3.76,1.93-3.96,2.52-.16.48.26.7.36,1.08l1.08,3.42-1.98.54-4.86-8.64c1.67-2.15,7.78-8.98,10.08-9.36Z"
        />

        <path
          class="cls-35"
          d="M180.75,84.61s.43-.05.36.36c-.77.56-2.91,1.91-3.24,2.7-.85,2.03.5,2.64.36,3.24-.07.32-4.01,3.1-4.68,4.68-.82,1.93-2.46,12.53,1.62,11.7,1.05-.21,3.99-6.33,5.22-7.92l4.86,8.64,1.98-.54-1.08-3.42c.85,3.32,3.61,4.51,1.44,9-.82,1.7-3,2.67-4.68,3.24-.02-.01.13-.26-.36-.36,1.65-2.16,4.3-4,3.42-7.2-2.49,7.03-7.84,10.04-13.5,3.78-2.06-2.27-2.95-6.21-5.4-8.1,3.2-7.26,5.53-16.71,13.68-19.8Z"
        />

        <g>
          <path
            class="cls-73"
            d="M274.73,57.97l-12.96,3.6c-9.34.69-29.88,2.19-38.17,4.68,3.15-2.42,11.48.8,8.64-5.4,8.69-1.3,17.13-3.52,25.74-5.04,5.22-.92,10.95-1.02,15.84-2.52-11.77,1.17-23.53,3-35.11,5.4-2.57-.42-1.72-1.07-2.88-2.88,13.72-3.61,28.87-5.35,42.31-9,.25-.07,1.73-.51,1.08-1.08l-52.03,11.52c.64-1.31,1.43-2.36,2.16-3.6.08-.05.28.06.36,0,18.87-7.43,39.41-9.83,59.23-14.04l-11.88,1.08c-10.06,3.27-21.1,4.59-31.51,7.2-1.12-1.21-3.16,1.23-2.88-1.08,15.78-4.53,30.77-10.15,46.99-13.68,2.82-.61,7.15-.43,9.18-2.16.97-.06,2.26.3,3.06-.36,1.86,1.15-3.99,5.31-4.5,5.94-3.63,4.54-3.49,3.98-7.38,7.74-1.66,1.61-2.24,3.8-4.32,5.4-1.44,1.11-4.45,1.79-5.4,2.52-1.02.79-3.76,4.17-5.58,5.76Z"
          />

          <path
            class="cls-73"
            d="M238.72,58.69c-3.57.74-7.08,1.69-10.62,2.52-1.12.26-1.74-1.01-1.8.72,1.98-.3,3.97-.79,5.94-1.08,2.84,6.2-5.49,2.98-8.64,5.4-.9.27-1.6.69-2.52.9-.06.84,1.09.54,1.62.54,6.65.02,32.91-3.71,39.61-5.4.38-.1,1.72-.39,1.62-.9-.04-.16-1.81.15-2.16.18l12.96-3.6c-3.22,2.81-3.92,3.5-6.84,6.48-.7.76-2.23.32-2.34.36-6.76,2.55-12.73,4.93-20.16,5.04-1.04.02-1.42-.26-1.26,1.08-7.78.39-16.67,1.38-24.3.72-.6-.05-1.8-.3-1.62.72-.48-.01-.96.01-1.44,0,.3-.3.33-1.04.36-1.08.84-1.09,1.7-2.11,2.52-3.24,1.27-1.74,5.24-8.16,6.12-9,.19-.18,1.27-.99,1.44-1.08,1.27-.63,6.74-1.66,8.64-2.16,1.16,1.81.31,2.46,2.88,2.88Z"
          />

          <path
            class="cls-76"
            d="M251.32,71.29c0,1.31.38,1.18-.9,1.44-3.58.72-8.24-.85-10.98,1.98,4.87.74,9.68.7,14.58.54.26,0,.02.78.54.72-.87,4-5.49,4.25-7.38,5.76-.61.49-.88,1.88-1.98,2.88.17-1.04-.64-.67-1.44-.72l.36-.72c.8-.12,2.85-.28,2.16-1.8,1.27-.33,6.26-2.31,6.12-3.96l-38.89.36c-.35-.03-.73.03-1.08,0,.81-.96,1.41-2.26,2.16-3.24.41-.54,1.55-1.27,1.8-2.16.12,0,.24,0,.36,0,.48.01.96-.01,1.44,0,11.59.28,21.56.22,33.13-1.08Z"
          />

          <path
            class="cls-76"
            d="M204.51,94.34c-.48.76-.51.84,0,1.62,2.97,4.52,7.16,6.91,12.06,7.02.12,0,1.49-2.15,1.62.36-4.05,2.51-4.75,2.83-8.28,5.76-.44-.15-.65-.51-1.08-.72-7.86-3.79-8.83-7.21-14.04-12.96l3.96-3.24h.36c.04,2.11,12.61,14.24,13.32,12.42l-12.6-12.6c1.22-.68,3.53,1.68,4.68,2.34Z"
          />

          <path
            class="cls-73"
            d="M267.88,64.45c-1.81,1.85-7.81,5.11-7.92,5.58-.14.58,1.07,1.65-.18,3.42-.44.63-4.2,2.4-5.22,2.52-.52.06-.28-.73-.54-.72-4.9.16-9.72.2-14.58-.54,2.74-2.83,7.4-1.26,10.98-1.98,1.28-.26.9-.13.9-1.44,2.33-.26,4.83-.12,7.02-1.08l-14.22.72c-.16-1.34.22-1.06,1.26-1.08,7.44-.11,13.4-2.49,20.16-5.04.11-.04,1.64.4,2.34-.36Z"
          />

          <path
            class="cls-62"
            d="M199.83,103.34c-3.99,4.7-.96,10.1,5.22,8.28l-.54,1.44c-.41.11-.86.33-1.08.36-1.63.25-3.43-.05-5.04-.36-3.82-3.49-6.73-7.76-8.64-12.6,1.33-1.12,2.71-3,4.32-3.96,1.35,1.85,4.15,5.33,5.76,6.84Z"
          />

          <path
            class="cls-32"
            d="M298.85,30.97c-2.03,1.73-6.36,1.55-9.18,2.16-16.21,3.53-31.21,9.15-46.99,13.68-.38.11-2.08,1.23-2.16.18,1.11-.49,2.22-.95,3.24-1.62.17-.11.92.19,1.08-.18.07-.17-.8-.05-.36-1.26,10.33-2.49,20.4-6.27,30.79-8.64,6.74-1.54,16.89-3.92,23.58-4.32Z"
          />

          <path
            class="cls-76"
            d="M199.83,103.34c2.13,1.99,6.08,5.37,9,5.04.43.21.64.57,1.08.72-1.73,1.43-2.83,3.26-5.4,3.96l.54-1.44c-6.18,1.82-9.21-3.58-5.22-8.28Z"
          />

          <path
            class="cls-57"
            d="M223.6,66.25c8.29-2.5,28.83-3.99,38.17-4.68.35-.03,2.12-.35,2.16-.18.1.51-1.24.8-1.62.9-6.7,1.7-32.96,5.42-39.61,5.4-.53,0-1.68.3-1.62-.54.92-.21,1.62-.63,2.52-.9Z"
          />

          <path
            class="cls-57"
            d="M232.24,60.85c-1.97.29-3.96.78-5.94,1.08.06-1.73.68-.46,1.8-.72,3.55-.83,7.05-1.78,10.62-2.52,11.58-2.4,23.34-4.23,35.11-5.4-4.89,1.5-10.62,1.6-15.84,2.52-8.61,1.52-17.06,3.74-25.74,5.04Z"
          />

          <path
            class="cls-57"
            d="M235.84,55.81c-1.9.5-7.37,1.53-8.64,2.16-.59-.04-.16-.38,0-.72l52.03-11.52c.65.57-.83,1.01-1.08,1.08-13.44,3.65-28.58,5.4-42.31,9Z"
          />

          <path
            class="cls-57"
            d="M229.72,53.65c.08-.06,1.01-1.08,1.44-1.44,4.75-1.74,9.49-3.09,14.4-4.32,10.41-2.61,21.45-3.93,31.51-7.2l11.88-1.08c-19.82,4.21-40.36,6.61-59.23,14.04Z"
          />

          <path
            class="cls-21"
            d="M243.76,45.37c-1.02.67-2.13,1.13-3.24,1.62.08,1.05,1.78-.07,2.16-.18-.28,2.31,1.76-.13,2.88,1.08-4.91,1.23-9.66,2.58-14.4,4.32.63-.52,1.53-1.87,2.16-2.52s1.77-1.03,1.8-2.16c.87-.29,1.79-.58,2.7-.72-3.52-1.17,4.41-1.41,5.94-1.44Z"
          />

          <g>
            <path
              class="cls-76"
              d="M246.28,81.37c-.05.01-.94-1.08-1.08.18.23.26.96-.45,1.08-.18.69,1.52-1.36,1.68-2.16,1.8-.85.13-1.96-.04-2.88,0l-25.56-1.8c-.37-.02-1.75-.1-1.8.18,9.69,2.6,19.94,1.74,29.88,2.34.8.05,1.61-.32,1.44.72-2.07,1.88-7.05,6.47-9.18,7.92-1.46,1-4.7,1.48-5.76,2.16-1.11.72-1.95,2.76-3.24,3.6-2.53,1.64-5.89,3.23-8.82,5.04-.13-2.51-1.5-.36-1.62-.36-4.9-.11-9.1-2.5-12.06-7.02-.51-.78-.48-.86,0-1.62,4.52,2.56,10.05,5.86,15.3,6.12-6.98-2.22-13.64-5.37-19.26-10.08.73-.58,1.16-1.21,1.8-1.8l25.74,6.84-23.94-8.28c.88-.87,1.68-1.97,2.52-2.88,1.04-1.12,1.95-2.54,2.88-3.6.78-.89,2.18-1.47,2.52-2.88.12,0,.24,0,.36,0,.35.03.73-.03,1.08,0,12.96.97,25.98,1.81,38.89-.36.14,1.65-4.85,3.63-6.12,3.96Z"
            />

            <g>
              <path class="cls-57" d="M252.4,77.41c-12.91,2.17-25.93,1.33-38.89.36l38.89-.36Z" />

              <path
                class="cls-57"
                d="M200.55,90.37c5.62,4.71,12.28,7.86,19.26,10.08-5.25-.27-10.79-3.56-15.3-6.12-1.16-.66-3.46-3.02-4.68-2.34l12.6,12.6c-.71,1.82-13.28-10.31-13.32-12.42-.44-1.92.88-1.35,1.44-1.8Z"
              />

              <path
                class="cls-64"
                d="M204.15,87.13l23.94,8.28-25.74-6.84s.32-.68.36-.72c.45-.42,1.38-.66,1.44-.72Z"
              />

              <path
                class="cls-57"
                d="M215.68,81.37c8.49.44,16.98,2.19,25.56,1.8.92-.04,2.03.13,2.88,0l-.36.72c-9.95-.6-20.19.26-29.88-2.34.05-.28,1.43-.2,1.8-.18Z"
              />

              <path class="cls-89" d="M241.24,83.17c-8.59.39-17.07-1.36-25.56-1.8l25.56,1.8Z" />

              <path class="cls-57" d="M210.09,85.33l26.46,4.5c-.01,1.37-24.75-2.69-26.46-4.5Z" />

              <path
                class="cls-76"
                d="M246.28,81.37c-.12-.27-.85.44-1.08.18.14-1.26,1.03-.17,1.08-.18Z"
              />
            </g>
          </g>

          <path
            class="cls-57"
            d="M251.32,71.29c-11.57,1.3-21.53,1.36-33.13,1.08-.18-1.02,1.02-.77,1.62-.72,7.63.66,16.53-.33,24.3-.72l14.22-.72c-2.19.96-4.7.82-7.02,1.08Z"
          />

          <path
            class="cls-45"
            d="M194.79,95.42c5.21,5.76,6.18,9.17,14.04,12.96-2.92.33-6.87-3.05-9-5.04-1.62-1.51-4.41-4.99-5.76-6.84-.73-1-1.5-2.01-2.16-3.06.42-.01,2.76,1.85,2.88,1.98Z"
          />

          <path
            class="cls-43"
            d="M198.39,113.06c-6.84-1.33-8.08-5.8-12.6-10.08.2-.59,3.18-1.87,3.96-2.52,1.91,4.84,4.82,9.11,8.64,12.6Z"
          />
        </g>

        <path
          class="cls-26"
          d="M190.83,117.02c-1.31.25-3.83,1.37-4.32,2.16-2.56-.47-2.33-2.25-3.6-2.88,1.68-.58,3.86-1.54,4.68-3.24.47,1.71,1.94,2.91,3.24,3.96Z"
        />

        <path
          class="cls-50"
          d="M216.76,151.22l-2.88,1.8c-.23-.65-.75-1.13-1.08-2.16,1.66-.33,2.85-.07,3.96.36Z"
        />

        <path
          class="cls-55"
          d="M180.03,80.65c-.06,1.09-.23,2.91.72,3.96-8.15,3.09-10.49,12.54-13.68,19.8-1.25,2.84-2.43,6.23-4.32,8.46-.24-1.04.19-1.84.36-2.7.76-3.74,2.64-7.33,3.6-10.98.86-3.29,1.68-11.72,2.88-14.04,1.33-2.58,7.85-5.21,10.44-6.66-.03.71.04,1.45,0,2.16Z"
        />

        <path
          class="cls-87"
          d="M180.39,119.18c.06.03-.05.59.9,1.08.9.46,2.74-.06,3.78.9.69.64,1.95,7.05,2.16,8.46-.79-.33-2.37.19-4.14-.72-3.04-1.57-5.66-9.53-8.82-11.7-.11-1.25,5.74,1.79,6.12,1.98Z"
        />

        <path
          class="cls-55"
          d="M196.23,140.06c-.81-.66-4.58-4.35-5.4-5.22-.45-.49-2.25-4.27-2.52-4.5,1.66-.26,2.67-2.49,3.42-2.88.99-.51,4.19.03,5.22-2.34-2.39,3.51-.51,8.38-5.4,9.72,3.97,3.01,5.98-.98,9.36-2.16-1.4,2.57-.94,6.71-4.68,7.38Z"
        />

        <path
          class="cls-55"
          d="M214.24,160.59c-.09-.09-.79.11-.9,0-3.37-3.32-6.55-7.92-9.18-11.88,2.16.47,4.67-1.45,5.76-.18l4.32,12.06Z"
        />

        <path
          class="cls-55"
          d="M202.71,145.46l-1.26,1.08c-.29-.03-2.67-4.25-2.7-5.04,2.88.73,5.7.69,8.1-1.08-.95,2.4-3.34,2.08-4.14,5.04Z"
        />

        <path
          class="cls-85"
          d="M188.31,77.05l-8.28,3.6c.04-.71-.03-1.45,0-2.16,2.47-1.39,5.09-2.52,7.56-3.96.09-.05.27.05.36,0,.69.83.3,2.15.36,2.52Z"
        />

        <g>
          <path
            class="cls-1"
            d="M214.24,40.33c.08.98.87,1.82.54,2.88.5.2.9-.72,1.26-1.08h.36c-.64.87-.76,2.6-1.08,3.24-.48.31-.68.69-.72.72-.38.25-.72.48-1.08.72-.34.23-.74.49-1.08.72-.37.25-.7.45-1.08.72-.32.23-.6.36-1.08.72-.5.38-.94.69-1.44,1.08-1.21.95-2.34,2.13-3.42,3.24-1.28.06.92-1.17-.36-1.08-2.07.15-13.63,12.17-15.3,14.76-3.76,1.63-7.43,3.91-11.52,4.68.98-.88,1.64-2.25,2.52-3.24,6.18-1.36,9.99-7.96,14.58-12.24,6.11-5.69,12.7-10.99,18.9-16.56,0,.24-.02.48,0,.72Z"
          />

          <path
            class="cls-9"
            d="M244.84,42.85c-.08.31-.25.78-.36,1.08-.44,1.21.43,1.09.36,1.26-.16.37-.91.07-1.08.18-1.53.03-9.46.27-5.94,1.44-.91.14-1.83.43-2.7.72-8.96,2.96-17.31,7.01-25.92,10.8l8.64-7.2c7.76-4.62,16.41-9.13,25.56-10.08.46-.05,2.36-.46,2.52-.18-.31.88-.81.99-1.08,1.98Z"
          />

          <path
            class="cls-11"
            d="M222.16,31.69c-2.01,3.26-5.14,5.43-7.92,7.92-6.21,5.58-12.79,10.87-18.9,16.56-4.59,4.28-8.4,10.88-14.58,12.24,12.56-14.11,27.17-26.55,42.13-38.17.08.64-.43.96-.72,1.44Z"
          />

          <path
            class="cls-70"
            d="M243.4,41.05c-9.15.96-17.81,5.46-25.56,10.08-3.04,1.81-5.88,3.93-9,5.58,3.05-2.43,6.37-5.05,9.72-7.02,6.99-4.11,16.85-8.58,24.84-8.64Z"
          />

          <g>
            <path
              class="cls-9"
              d="M244.84,42.85c.27-.99.77-1.1,1.08-1.98-.16-.28-2.06.13-2.52.18-7.99.06-17.85,4.53-24.84,8.64-2.95.86-.87-1.71,0-2.52,5.66-5.24,21.6-9.19,28.98-12.6.34-.16,2.31-.85,1.8-1.44l-32.23,14.04c-.1-.49-1.08-.27-.72-1.26.11-.29,2.74-1.33,2.52-2.34,12.77-7.87,25.88-15.54,39.79-21.24,1.28-1.11-.83-.43-1.08-.36-1.03.31-3.17,1.31-4.32,1.8-12.84,5.49-25.84,14.1-37.63,21.6-.09.05-.27-.05-.36,0,.32-.64.44-2.37,1.08-3.24,2.79-3.79,13.89-8.63,17.46-12.6-5.86,3.58-12.95,7.75-17.82,12.6-.36.36-.76,1.28-1.26,1.08.33-1.06-.46-1.9-.54-2.88,16.85-14.69,35.7-27.11,56.17-36.19l-5.22,1.62c-14.78,6.56-27.58,15.99-40.69,25.2-.46.32-1.88,1.62-2.34.72.29-.48.8-.81.72-1.44,7.18-5.58,16.04-12.33,23.58-17.28,9.15-6.01,20.15-12.37,31.33-12.96,1.72,1.1-4.74,7.63-5.22,8.46-1.53,2.69-1.42,5.43-3.96,8.64-1.33,1.68-4.21,3.26-5.04,4.32-1.68,2.14-2.66,5.82-5.04,8.28-1.04,1.08-4.01,2.52-4.5,3.06-3,3.27-4.35,7.87-9.18,10.08Z"
            />

            <g>
              <path
                class="cls-65"
                d="M214.24,40.33c-.02-.24,0-.48,0-.72,2.78-2.5,5.91-4.66,7.92-7.92.46.9,1.88-.4,2.34-.72,13.11-9.22,25.9-18.64,40.69-25.2l5.22-1.62c-20.47,9.08-39.32,21.5-56.17,36.19Z"
              />

              <path
                class="cls-82"
                d="M218.92,43.57c-1.04.64-2.36,1.24-3.24,1.8,11.79-7.5,24.78-16.11,37.63-21.6,1.15-.49,3.3-1.49,4.32-1.8.25-.07,2.36-.75,1.08.36-13.9,5.7-27.02,13.37-39.79,21.24Z"
              />

              <path
                class="cls-78"
                d="M266.26,11.16c.28-.03.82-.09.9.18-3.45,1.95-7.41,3.35-10.98,5.22-6.84,3.58-13.42,8.4-20.34,11.34,5.15-3.2,10.31-6.68,15.66-9.54,1.83-.98,13.83-7.11,14.76-7.2Z"
              />

              <path
                class="cls-82"
                d="M218.56,47.17l-2.16.54c.1-.31.73-.5.72-.54l32.23-14.04c.51.59-1.46,1.28-1.8,1.44-7.39,3.41-23.33,7.36-28.98,12.6Z"
              />

              <path
                class="cls-82"
                d="M216.4,42.13h-.36c4.88-4.85,11.96-9.02,17.82-12.6-3.57,3.97-14.67,8.81-17.46,12.6Z"
              />
            </g>
          </g>

          <g>
            <path
              class="cls-72"
              d="M217.12,47.17s-.62.23-.72.54l2.16-.54c-.87.81-2.95,3.38,0,2.52-3.35,1.97-6.67,4.59-9.72,7.02,3.12-1.65,5.96-3.77,9-5.58l-8.64,7.2c-6.49,2.86-12.93,5.81-19.44,8.64,1.67-2.59,13.23-14.61,15.3-14.76,1.28-.09-.92,1.14.36,1.08,1.08-1.11,2.21-2.29,3.42-3.24.85.25,1.13-.86,1.44-1.08.26-.18.79-.53,1.08-.72.16-.1,1.03.04,1.08-.72.34-.23.74-.49,1.08-.72.74.2.75-.35,1.08-.72.12-.13.18.37.72-.72.09-.05.27.05.36,0,.88-.56,2.2-1.16,3.24-1.8.22,1.01-2.41,2.05-2.52,2.34-.36.99.62.77.72,1.26Z"
            />

            <g>
              <path
                class="cls-51"
                d="M210.27,48.97c-.31.22-.59,1.33-1.44,1.08.5-.39.94-.7,1.44-1.08Z"
              />

              <path
                class="cls-51"
                d="M211.35,48.25c-.29.19-.82.54-1.08.72.48-.36.76-.49,1.08-.72Z"
              />

              <path
                class="cls-51"
                d="M212.43,47.53c-.05.76-.92.62-1.08.72.38-.27.71-.47,1.08-.72Z"
              />

              <path class="cls-51" d="M214.6,46.09c-.33.37-.34.92-1.08.72.36-.24.7-.47,1.08-.72Z" />

              <path class="cls-51" d="M214.6,46.09s.24-.41.72-.72c-.54,1.09-.6.59-.72.72Z" />

              <path
                class="cls-9"
                d="M207.03,54.37c-.81.81-1.49,2.28-2.88,2.34.31-1.28,1.99-1.74,2.88-2.34Z"
              />

              <path
                class="cls-9"
                d="M203.25,57.25c1.14.18-1.24,1.96-1.44,1.8-.07-.72,1.07-1.25,1.44-1.8Z"
              />

              <path
                class="cls-9"
                d="M207.03,54.37c.42-.42.72-1.09,1.26-1.44.59,1.09-.96,1.24-1.26,1.44Z"
              />
            </g>
          </g>
        </g>

        <path
          class="cls-60"
          d="M189.03,80.29c.33.69,2.96,2.35,3.24,4.14.31,1.98-.65,3.99-1.8,5.58-2.3.38-8.41,7.21-10.08,9.36-1.24,1.59-4.17,7.71-5.22,7.92-4.08.83-2.44-9.77-1.62-11.7.67-1.58,4.61-4.36,4.68-4.68.14-.6-1.21-1.21-.36-3.24.33-.79,2.47-2.14,3.24-2.7,2.19-1.61,5.65-2.88,7.92-4.68Z"
        />

        <path
          class="cls-26"
          d="M188.31,77.05c.09.53.59,2.97.72,3.24-2.27,1.8-5.73,3.07-7.92,4.68.06-.41-.34-.34-.36-.36-.95-1.05-.78-2.87-.72-3.96l8.28-3.6Z"
        />

        <g>
          <path
            class="cls-26"
            d="M172.47,74.89c-.82.58-1.74.89-2.52,1.44-9.92-3.58-12.6-14.48-17.64-22.68-1.12-1.82-2.93-3.57-4.32-5.22l-7.2-13.14c4.29,1.53,9.79,5.59,12.6,9.18,7.71,9.85,5.88,24.88,19.08,30.43Z"
          />

          <path
            class="cls-55"
            d="M140.78,35.29l7.2,13.14c1.39,1.65,3.2,3.4,4.32,5.22l-1.08.36c-.25-.86-.78-2.14-1.62-2.52-1.84-.83-11.64-.35-13.5.72-.9-1.69-2.58-3.8-1.8-5.76l9.72.54c-3.32-2.01-7-1.17-10.44-1.26-.55-.01-.66.64-1.44-.54.14-2.34,11.02.93,12.6-1.44-8.33-2.86-17.3-3.79-25.56-.18.67-.94,2.52-.69,2.16-2.16,2.75-.94,13.68-3.07,14.58-3.6.62-.36.41-.74.54-1.08.55-1.41-2.09-2.31-3.42-2.52-12.91-2.04-21.09,6.88-31.51,11.16,11.94-8.7,24.04-15.51,39.25-10.08Z"
          />

          <path
            class="cls-46"
            d="M48.25,51.13v.72c-1.56.22-3.23.17-4.68.9,9.11.45,18.24-1.54,27.36-1.26,2.89.09,8.95.73,12.78,1.08,5.92.53,15.66,5,19.26-1.08.59.01,1.21.03,1.8,0,.34.68.93.83.72,1.8-.11.48-2.73,2.61-3.24,2.88-.65.35-1.86,1.02-2.52,1.08-21.4-6.37-42.55-1.87-64.27-2.16-.65-.78,4.44-2.35,5.04-2.52,2.45-.68,5.23-1.07,7.74-1.44Z"
          />

          <path
            class="cls-36"
            d="M136.46,36.73c-11.69-3.63-24.94,3.62-33.49,11.34,6.29-.33,12.3-4.6,18.36-6.66.36,1.47-1.49,1.22-2.16,2.16-4.2,1.83-9.87,7.69-14.4,7.92-.59.03-1.21.01-1.8,0-.45,0-1.67-.74-2.88-.72,0-1.24-2.54-2.01-3.6-2.16l-.72-1.08c1.5-.32,4.22-1.53,5.76-2.16,10.42-4.28,18.59-13.2,31.51-11.16,1.33.21,3.97,1.11,3.42,2.52Z"
          />

          <path
            class="cls-47"
            d="M142.58,67.69c1.17,4.81,4.44,10.21-4.32,9.72,1.7-3.75-2.37-5.98-2.52-6.66-.09-.41,1.34-2.36.36-4.68-.22-.53-2.02-1.71-2.16-2.16-.52-1.65.86-4.53-2.88-6.3,7.34.75,7.63,4.67,11.52,10.08Z"
          />

          <path
            class="cls-47"
            d="M128.54,57.61c4.25,1.02,7.88,6.43,1.44,7.02,3.42.28,5.96-.19,5.76,4.68-1.01,1.57-4.14,2.34-5.58,1.62-3.13-1.57-.39-4.37-.9-6.66-.06-.27-1.38-1.18-1.44-1.44-.21-1,1.21-3.38-1.08-4.86.66-.04.96-.37,1.8-.36Z"
          />

          <path
            class="cls-47"
            d="M137.9,77.77c-1.35,1.82-5.51,2.58-7.2,1.08-2.3-2.03-.53-3.6,0-5.22.09-.26-.85-1.56-.18-1.98.21-.13,4.8-.42,5.04-.36,1.45.39,2.9,5.07,2.34,6.48Z"
          />

          <path
            class="cls-47"
            d="M129.98,79.21c1.25,4.02-.62,4.45-4.32,5.04-.57.09-.93-.49-1.8-.36-.04-1.44.42-2.52.36-4.14-.02-.57-1.09-1.7-1.08-1.8.1-1.83,4.3-2.16,5.58-1.62.41.17,1.1,2.36,1.26,2.88Z"
          />

          <path
            class="cls-3"
            d="M119.18,64.81c-.06,2.18,1.3,2.8-1.08,4.5,1.66.66.99.41,1.8,1.62.13.19-.27.93.72.72-1.73.89-1.67.22-1.98.36-.15.07-2.36,2.11-2.52,2.16-.72.24-.5-.72-.54-.72.43-1.83-1.59-1.25-1.8-1.62-.25-.45,1.91-2.84-1.8-2.7.24-.57.62-.59,1.08-1.44.03-.05.54.16.72-.18.34-.64-1.9-1.49,1.08-1.98,2.58-.43,1.63,1.12,3.6-.72.05-.05.49.03.72,0Z"
          />

          <path
            class="cls-47"
            d="M125.3,57.97c2.87,1.86,3.32,5-.72,5.58,5.99-1.05,4.71,5.71-.18,5.22,1.3-2.58-.41-3.95-.54-4.86-.34-2.46,1.28-3.56-2.16-5.94.22-.06,2.88.1,3.6,0Z"
          />

          <path
            class="cls-70"
            d="M119.72,77.77c5.48-.33,4.58,6.69,1.44,6.12-.58-.11-3.8-4.17-4.5-4.86.05-.45,2.73-1.24,3.06-1.26Z"
          />

          <path
            class="cls-47"
            d="M127.64,68.77c.58.11,4.17,5.96.36,6.84-4.81,1.12-1.41-3.43-3.78-5.94.96.34,3.25-.93,3.42-.9Z"
          />

          <path
            class="cls-47"
            d="M119.18,64.81c-.23.03-.67-.05-.72,0l-1.8-3.06c2.92-.23,2.76-.79,4.32-1.98,3.14-2.38,3.13,6.02-.18,4.68-1.09-.44.17-2.42-1.44-2.88.42,1.14-.15,2.28-.18,3.24Z"
          />

          <path
            class="cls-70"
            d="M120.62,58.69s-.33.7-.36.72c-.43.34-.59,1.98-2.7,1.44-.19-.05-3.05-2.55-2.34-3.24,1.91.1,3.83-.34,5.4,1.08Z"
          />

          <path
            class="cls-47"
            d="M122.96,64.45c2.11.2,1.68,3.74-1.8,2.88-3.75-.93.09-3.04,1.8-2.88Z"
          />

          <path
            class="cls-47"
            d="M123.68,70.93c1.39.13,2.24,7.27-3.06,1.62.81.14,2.84-1.64,3.06-1.62Z"
          />

          <path
            class="cls-70"
            d="M120.62,71.65c-.99.21-.59-.53-.72-.72l1.8-.54c-4.69-3.67,7.16-2.97-1.08,1.26Z"
          />

          <path
            class="cls-70"
            d="M115.58,73.45c-.73.04-.62,1.49-2.16-.54.39-1.23-1.76-3.01-1.44-3.78,3.71-.14,1.55,2.25,1.8,2.7.21.37,2.23-.21,1.8,1.62Z"
          />

          <path
            class="cls-51"
            d="M116.48,74.89c1.19,1.15,2.73.98,1.44,2.88-.73-.99-2.54-1.61-1.44-2.88Z"
          />

          <path
            class="cls-36"
            d="M150.86,60.85c.06.12,1.29.57,1.8,1.98,2.83,7.76,4.1,14.87,14.04,16.38-.49.51-1.39,1.43-1.44,2.16-.93.47-.78,1.11-2.16,1.08-4.18-.1-14.56-13.69-13.14-18.72-2.63,4.14-5.84,7-7.38.36-.19-.82.1-4.12-.54-5.4,1.19.95,4.34,1.22,5.4,1.8.95.51,2.4,4.97,3.42.36Z"
          />

          <path
            class="cls-60"
            d="M150.5,59.05c-.08.5.13,1.33.36,1.8-1.02,4.61-2.47.15-3.42-.36-1.06-.58-4.21-.85-5.4-1.8.64,1.28.35,4.58.54,5.4-.43-2.24-1.74-4.21-2.88-6.12-.36-.6-.62-1.24-1.08-1.8.69.27,2.05.52,2.7.72,2.88.89,6.27,1.24,9.18,2.16Z"
          />

          <path
            class="cls-26"
            d="M133.58,45.73l.72.72c-.78,1.96.9,4.07,1.8,5.76-.09.05-.6,1.12-1.08,1.08-.78-1.77-.23-2.4-.36-2.7-3.04-6.75-5.43-7.65-12.78-5.58-.25.07-1.56.8-.18.72-1.07.34-3.42,2.6-3.96,3.6-3.98,1.5-7.82,4.1-12.24,3.96.21-.97-.38-1.12-.72-1.8,4.54-.23,10.2-6.09,14.4-7.92,8.26-3.61,17.23-2.68,25.56.18-1.59,2.37-12.46-.9-12.6,1.44.78,1.18.89.53,1.44.54Z"
          />

          <path
            class="cls-81"
            d="M151.22,54.01c1.04,3.57-.43,3.31-.72,5.04-2.91-.92-6.3-1.27-9.18-2.16-.66-.2-2.01-.45-2.7-.72-2.13-.84-2.74-.92-3.6-2.88.48.04.99-1.03,1.08-1.08,1.86-1.07,11.67-1.55,13.5-.72.85.38,1.37,1.66,1.62,2.52Z"
          />

          <path
            class="cls-17"
            d="M129.62,48.25c-2.68-1.3-3.88-2.39-7.02-2.16-.08,0-2.13.77-.54.72-1.53.37-3.61,3.04-3.6,4.68l-1.44.36c.12-.74.38-1.89.72-2.52.54-1,2.9-3.26,3.96-3.6,2.6-.83,6.37.17,7.92,2.52Z"
          />

          <g>
            <path
              class="cls-56"
              d="M135.02,53.29c.86,1.96,1.47,2.04,3.6,2.88.46.56.72,1.2,1.08,1.8,1.81,3.4,2.04,6.27,2.88,9.72-3.89-5.42-4.19-9.33-11.52-10.08-1-.1-1.56,0-2.52,0-.84,0-1.14.32-1.8.36-.39.02-.35-.15-1.44,0-.72.1-3.39-.06-3.6,0-.84.22-.52.17-1.08.72-1.57-1.42-3.49-.98-5.4-1.08-.66-.04-1.49-.25-2.16-.36-.73.41-.5,1.73.36,1.44-.4,2.1-1.22,4.79,1.44,6.84-2.98.49-.74,1.34-1.08,1.98-.18.34-.69.13-.72.18-1.36-1.11-.95-2.04-2.16-3.24-.18-.18-.91-.54-1.08-.72-.24-.24-2.53-1.5-2.52-2.34,0-.63,5.08-3.82-1.26-1.62-.58-1.69-1.21-2.64-3.78-3.6.51-.27,3.13-2.4,3.24-2.88,4.43.14,8.26-2.46,12.24-3.96-.34.63-.6,1.78-.72,2.52-.16.97-.98,2.39.18,3.24,1.5,1.1,10,1.72,11.7-.18-.01-.13-1.29-.2-1.44-.18,2.26-2.02,3.42-2.53,2.52-5.4-.11-.37-.07-.63-.36-1.08-1.55-2.35-5.32-3.35-7.92-2.52-1.38.08-.07-.65.18-.72,7.35-2.07,9.74-1.17,12.78,5.58.13.3-.42.93.36,2.7Z"
            />

            <g>
              <path
                class="cls-39"
                d="M118.46,51.49c.01,5.08,6.12,3.57,9,3.24.15-.02,1.43.05,1.44.18-1.7,1.9-10.2,1.28-11.7.18-1.16-.85-.34-2.27-.18-3.24l1.44-.36Z"
              />

              <path
                class="cls-78"
                d="M111.08,57.25c1.36,0,1.05,2.42.36,2.52-.41.06-2.12-2.51-.36-2.52Z"
              />

              <path
                class="cls-84"
                d="M114.68,53.65c.18-.04,1.39,1.27.36,1.44-1.47.24-.91-1.33-.36-1.44Z"
              />

              <path class="cls-29" d="M109.28,54.01c.33.02.77,1.84,0,1.8-.73-.04-.62-1.83,0-1.8Z" />

              <path
                class="cls-29"
                d="M111.8,53.65c.22.02.86.86.36,1.08-.77.34-1.05-1.14-.36-1.08Z"
              />
            </g>
          </g>

          <path
            class="cls-60"
            d="M152.31,53.65c5.04,8.21,7.72,19.1,17.64,22.68-.84.59-2.5,2.11-3.24,2.88-9.94-1.51-11.21-8.62-14.04-16.38-.51-1.41-1.74-1.86-1.8-1.98-.23-.47-.44-1.3-.36-1.8.29-1.73,1.76-1.47.72-5.04l1.08-.36Z"
          />

          <path
            class="cls-23"
            d="M136.46,36.73c-.13.34.08.72-.54,1.08-.9.53-11.83,2.66-14.58,3.6-6.06,2.06-12.07,6.33-18.36,6.66,8.54-7.72,21.79-14.97,33.49-11.34Z"
          />

          <path class="cls-42" d="M134.3,46.45l-.72-.72c3.44.09,7.13-.75,10.44,1.26l-9.72-.54Z" />

          <path
            class="cls-88"
            d="M96.5,48.61c1.06.15,3.6.92,3.6,2.16-9.71.15-19.47.32-29.16.72-9.13-.28-18.25,1.71-27.36,1.26,1.45-.73,3.13-.68,4.68-.9,9.9-1.43,39.42-4.51,48.25-3.24Z"
          />

          <path
            class="cls-4"
            d="M100.1,50.77c1.21-.02,2.43.71,2.88.72-3.6,6.08-13.35,1.61-19.26,1.08-3.83-.35-9.89-.99-12.78-1.08,9.7-.4,19.46-.57,29.16-.72Z"
          />

          <g>
            <path
              class="cls-88"
              d="M102.26,56.17c2.57.96,3.2,1.91,3.78,3.6,6.34-2.2,1.27.99,1.26,1.62-.01.84,2.29,2.1,2.52,2.34-.8.43-.08,2.83.36,3.6l.36,1.62c-.17.35-1.07-.07-1.26-.18-1.56-.91-7.18-9.93-9.54-11.52.66-.06,1.87-.73,2.52-1.08Z"
            />

            <path
              class="cls-70"
              d="M110.9,64.45l1.08,3.42c-.73,1.66-1.19.53-1.8-.54-.44-.77-1.16-3.17-.36-3.6.17.18.9.54,1.08.72Z"
            />

            <polygon
              class="cls-20"
              points="106.4 60.13 106.58 60.67 106.04 60.85 105.86 60.67 106.4 60.13"
            />
          </g>

          <g>
            <path
              class="cls-3"
              d="M115.22,57.61c-.71.69,2.15,3.19,2.34,3.24,2.11.54,2.27-1.1,2.7-1.44l.72.36c-1.56,1.19-1.41,1.75-4.32,1.98l1.8,3.06c-1.97,1.84-1.02.29-3.6.72-2.66-2.05-1.85-4.75-1.44-6.84.22-1.16-.47-1.35-.36-1.44.67.11,1.5.32,2.16.36Z"
            />

            <path
              class="cls-70"
              d="M113.42,58.69c-.86.29-1.09-1.03-.36-1.44-.11.09.58.29.36,1.44Z"
            />

            <polygon class="cls-82" points="114.68 59.77 116.3 61.03 115.4 61.21 114.68 59.77" />
          </g>

          <g>
            <path
              class="cls-25"
              d="M129.98,49.33c.89,2.87-.26,3.38-2.52,5.4-2.88.33-8.99,1.84-9-3.24,0-1.64,2.07-4.32,3.6-4.68,2.93-.7,5.66.81,7.92,2.52Z"
            />

            <path
              class="cls-39"
              d="M129.62,48.25c.29.45.25.71.36,1.08-2.26-1.71-4.99-3.22-7.92-2.52-1.59.05.46-.71.54-.72,3.14-.23,4.34.86,7.02,2.16Z"
            />

            <path
              class="cls-56"
              d="M124.04,47.89c1.46.1,1.36,3.04-.72,2.52-1.58-.39-.13-2.58.72-2.52Z"
            />
          </g>
        </g>
      </g>

      <g>
        <path
          class="cls-37"
          d="M23.04,137.54l-2.16.18c4.68,3.74,5.8,8.99,10.8,12.78,1.21,3.61,3.52,8.83,1.44,12.6-.64-.25-1.14-5.94-2.34-5.04,0,2.31.36,4.31-.9,6.48l-2.52-8.1-1.08.9c-.05-.12-1.26-1.8-1.44-2.16-2.77-5.63-5.68-9.74-10.44-13.86,5.1,3.63,9.98,8.36,12.42,14.22l.18-1.62c-4.88-8.3-10.36-15.05-19.08-19.62-.63-.69-1.98-1.19-2.16-2.16,6.36,1.49,11.5,2.1,17.28,5.4Z"
        />

        <path
          class="cls-59"
          d="M36.37,164.91c-.77,7.64,10.01,19.21,15.12,25.02,1.12,1.27,2.36,2.45,3.42,3.78.78-.11.64-5.35.54-6.12-.1-1.25,1.06-.59,1.62-.36,3.84,1.6,4.52,2.17,8.82,2.88.12.02.24-.02.36,0-.22.71.97.96,1.44,1.08,1.18.3,3.27.9,4.32,1.08l-20.52,2.88c.06-.05.79-.96,1.08-1.08-.19-.82-2.19-1.62-2.88-2.52-.84-1.08-1.97-3.73-2.52-4.32l-12.78-16.56c-2.41-1.09-4.46-1.81-7.02-2.52,1.59-.27,2.96-1.64,4.32-2.16,1.72-.66,2.91-.76,4.68-1.08Z"
        />

        <path
          class="cls-33"
          d="M36.37,164.91c-1.77.32-2.96.42-4.68,1.08-2.18-1.3.41-1.01,1.44-2.88,2.08-3.78-.23-8.99-1.44-12.6-1.05-3.12-2.64-5.9-3.6-9,5.78,5.16,10.67,11.34,9.72,19.62-.1.89-1.31,2.45-1.44,3.78Z"
        />

        <path
          class="cls-40"
          d="M8.28,140.78c-1.07.27-.17,2.85,0,3.42,2.21,7.27,6.49,14.66,12.24,19.62-.03.02.02.51,0,.72-6.58-2.75-9.7-8.34-13.32-14.04-1.07-4.7-.75-11.29-1.44-16.2.53,1.66,1.81,4.77,2.52,6.48Z"
        />

        <path
          class="cls-37"
          d="M9.36,140.78c3.05,6.57,9.07,16.35,14.76,20.88-.46.78.31,2.98.72,3.6-.95.74-3.23-.27-4.32-.72.02-.21-.03-.7,0-.72.18-.11.98.19,1.08-.18s-5.67-4.18-4.5-5.94l2.7,1.62c-5.04-5.27-8.74-11.82-11.52-18.54-.71-1.71-1.99-4.82-2.52-6.48-.04-.13-.36-.17-.36-1.08,2.11,1.83,2.83,5.12,3.96,7.56Z"
        />

        <path
          class="cls-2"
          d="M7.92,134.3c.56.61,3.53,3.53,3.6,3.78.27,1.02-1.05.71-.72,2.16.13.57,6.55,7.66,7.56,9,1.44,1.91,2.61,4.15,3.96,6.12.33.48,1.05,1.95,1.8,1.26.02.38.88,2.35.18,2.88-5.75-5.59-10.14-12.36-14.94-18.72-1.13-2.45-1.85-5.73-3.96-7.56,0-.41-.19-1.06.36-1.08.18.97,1.53,1.47,2.16,2.16Z"
        />

        <path
          class="cls-37"
          d="M20.52,164.55c1.09.45,3.37,1.47,4.32.72.29.44,1.64.61,1.44,1.44-1.1.4-2.09.78-3.24,1.08-6.98-1.85-14.26-10.36-15.84-17.28,3.62,5.7,6.75,11.29,13.32,14.04Z"
        />

        <path
          class="cls-28"
          d="M23.04,137.54c2.33,1.33,3.14,2.27,5.04,3.96.96,3.1,2.55,5.88,3.6,9-5-3.79-6.12-9.04-10.8-12.78l2.16-.18Z"
        />

        <g>
          <path
            class="cls-28"
            d="M70.57,105.86c.97,3.77,1.66,7.72,4.86,10.44.38-4.04-2.86-8.07-1.62-11.16,1.14,2.85,2.74,5.56,4.14,8.28l-.72-7.2c1.73-.97,1.27,6.16,3.42,5.58l-1.8-10.44,3.06,9.54.18-7.74c1.45-2.16,1.56,4.63,2.34,4.5.61-8.53,1.79.83,1.62,3.24-.24,3.43-2.16,8.43-5.4,10.08-2.46-.54-4.1.08-6.48.72-5.8-8.98-8.58-7.98-7.56-21.24l1.98,4.68.54-6.66c.29,2.47.83,4.99,1.44,7.38Z"
          />

          <path
            class="cls-59"
            d="M80.65,120.98c.62.14,1.53,1.09,2.52.72-.61.86-4.18,5.95-4.32,6.3-1,2.57-2.87,20.39-4.5,21.06-9.69-4.28-19.68-2.21-29.88-2.52-.91-.62-1.08-1.68-1.62-2.52,2.02-1.72,6.16,1.46,8.46,1.8.34.05,6.51.08,6.84,0,1.25-.29.92-.07.9-1.44.59.14,1.5-.09,2.16,0,2.5,4.13,9.13-2.22,13.14-1.44.98-.63.33-1.76.54-2.52,1.83-6.64,3.15-12.73-.72-18.72,2.38-.64,4.02-1.26,6.48-.72Z"
          />

          <path
            class="cls-33"
            d="M83.17,121.7c-.99.37-1.9-.58-2.52-.72,3.24-1.65,5.16-6.65,5.4-10.08,1.76-8.67-1.81-15.07-5.4-22.5-.72-1.5-2.31-2.26-2.16-4.32,8.42,8.61,16.31,22.65,8.28,34.21-.92,1.32-2.71,2.16-3.6,3.42Z"
          />

          <path
            class="cls-2"
            d="M71.65,100.1c-.02,1.24.52,5.99-1.08,5.76-.61-2.4-1.15-4.91-1.44-7.38l-.54,6.66-1.98-4.68c.28-3.58,1-6.54,2.16-9.9.36-1.05,4.93-11.72,5.58-11.7,2.16.06-.91,5.26-.54,6.3-.59.44-.21-.93-.54-.9-1.86.17-1.59,13.96-1.62,15.84Z"
          />

          <path
            class="cls-37"
            d="M73.81,105.14c-1.24,3.09,2,7.12,1.62,11.16-3.2-2.72-3.89-6.67-4.86-10.44,1.6.23,1.06-4.52,1.08-5.76,1.44.97,1.56,3.54,2.16,5.04Z"
          />
        </g>

        <path
          class="cls-80"
          d="M33.13,163.11c-1.03,1.87-3.62,1.58-1.44,2.88-1.36.52-2.73,1.89-4.32,2.16-1.07-.3-2.62.09-4.32-.36,1.15-.3,2.14-.68,3.24-1.08,1.6-.58,2.62-.48,3.6-2.16,1.26-2.17.89-4.17.9-6.48,1.2-.9,1.7,4.79,2.34,5.04Z"
        />

        <path
          class="cls-56"
          d="M181.47,160.95c-2.9,3.78-9.58,4.23-8.64,10.44-.09-.03-.23.02-.36,0-.11-.02-.25,0-.36,0-1.17-1.63,1.62-4.57,1.08-5.4.01-1.29-3.46-.76-4.14-1.08-1.35-.64.46-1.63.18-1.98s-3.03.27-2.16-2.16c.39-1.09,5.76-1.11,7.92-3.06,1.97,1.05,5.21,1.38,6.48,3.24Z"
        />

        <g>
          <path
            class="cls-35"
            d="M178.95,211.35c2.88,2.97,8.25,4.37,11.7,6.84.34.25-.71.64.36,1.44,6,4.47,14.99,11.07,19.62,16.74,3.09,3.78,5.15,9.14,7.92,12.96.56.77.73,1.38,1.8.9,4.67,8.07,8.62,16.46,11.88,25.2l-.72,1.98c-9.8-16.98-23.85-31.74-40.69-41.77l13.86-1.26c-4.59-1.97-10.42-.66-14.76,1.08-.97-.68-1.97-1.33-3.06-1.8,2.02-1.42,5.47-.89,7.74-1.44.41-.1,2.43-.35,1.8-1.08-1.75.54-4.04.16-5.76.36-.28.03-.07.68-.36.72-1.87.23-3.24-1.27-4.5.72-3.18-1.45-6.22-3.25-9.36-4.68l16.38-3.24c-1.93-2.15-7.1-.23-10.08-.36-2.03,1.4-5.95,1.07-8.1,2.88-.53-.2-1.21-.39-1.8-.36.08-.37.3-.43.36-1.08.54-5.84,1.38-10.35,5.04-15.12.29.1.43.26.72.36Z"
          />

          <path
            class="cls-8"
            d="M217.48,268.96c-2.99-1.71-7.4-3.84-10.62-5.04-4.68-1.75-17.86-3.96-20.7-5.76-5.01-3.17-14.98-22.95-12.96-29.52,5.36,2.67,26.64,12.72,29.34,16.56.45.64.81,3.39,1.62,4.5,2.41,3.32,5.91,5.38,8.28,9,1.94,2.97,3.24,7.11,5.04,10.26Z"
          />

          <path
            class="cls-38"
            d="M154.83,207.03c7.88-.2,15.97,1.48,23.4,3.96-3.66,4.78-4.5,9.28-5.04,15.12-3.77-.22-7.4-4.95-11.16-4.32-4.01-6.38-11.6-11.38-18.72-13.32.44-.65,1.8-.34,2.52-.36,3.14-.08,6.12-1.01,9-1.08Z"
          />

          <path
            class="cls-35"
            d="M174.63,227.56c.54.2,1.28.48,1.8.72,3.14,1.43,6.18,3.23,9.36,4.68.14.06.67.54,1.08.72,1.09.47,2.09,1.12,3.06,1.8,4.34-1.74,10.17-3.05,14.76-1.08l-13.86,1.26c16.84,10.03,30.88,24.79,40.69,41.77l.72-1.98c1.22,3.26,3.45,7.39,3.06,10.8-2.49-7.09-11.38-13.59-17.82-17.28-1.8-3.15-3.1-7.29-5.04-10.26-2.37-3.62-5.87-5.69-8.28-9-.81-1.11-1.17-3.86-1.62-4.5-2.7-3.84-23.98-13.89-29.34-16.56-.47-.23-.34-.35-.36-.36.04-.34-.07-.75,0-1.08.59-.03,1.27.16,1.8.36Z"
          />

          <path
            class="cls-38"
            d="M172.83,228.28s-.11.13.36.36c-2.01,6.58,7.95,26.35,12.96,29.52-4.49-1.23-14.61-2.12-15.84-7.38-2.32-9.9-1.64-16.46-6.84-26.46,3.2.82,6.41,2.49,9.36,3.96Z"
          />

          <path
            class="cls-15"
            d="M181.83,212.43c.33.13,1.13.22,1.44.36.02.01-.12.15.36.36,3.6,1.59,7.91,3.91,11.16,6.12.57.39,1.33.73,1.8,1.08,1.95,1.46,3.68,3.32,5.4,5.04,7.04,7.03,13.4,16.26,18.36,24.84-1.07.48-1.24-.13-1.8-.9-2.77-3.82-4.83-9.18-7.92-12.96-4.64-5.67-13.63-12.28-19.62-16.74-1.07-.8-.02-1.19-.36-1.44-3.45-2.47-8.82-3.87-11.7-6.84.97.34,1.93.69,2.88,1.08Z"
          />

          <path
            class="cls-59"
            d="M173.19,226.12c-.06.65-.28.71-.36,1.08-.07.33.04.74,0,1.08-2.95-1.47-6.16-3.14-9.36-3.96-.41-.79-.96-1.76-1.44-2.52,3.76-.63,7.39,4.1,11.16,4.32Z"
          />

          <path
            class="cls-8"
            d="M176.43,228.28c-.53-.24-1.26-.52-1.8-.72,2.15-1.81,6.07-1.49,8.1-2.88,2.99.13,8.15-1.79,10.08.36l-16.38,3.24Z"
          />

          <path
            class="cls-8"
            d="M186.87,233.68c-.41-.18-.94-.66-1.08-.72,1.26-1.99,2.64-.49,4.5-.72.29-.04.08-.69.36-.72,1.73-.2,4.01.18,5.76-.36.63.73-1.39.98-1.8,1.08-2.28.55-5.72.02-7.74,1.44Z"
          />
        </g>

        <g>
          <path
            class="cls-8"
            d="M109.1,115.94c.11,2.43,1.24,9.2.72,10.98-.13.43-4.87,4.28-5.76,5.4-5.4,6.84-11.19,18.54-12.24,27.18-.22.03-.62-.06-.72,0-1.16-.88-2.11-1.96-3.24-2.88-.38-.31-.97-.51-1.08-1.08.35.11.89.13,1.26.36.84-.47.65-2.02.9-2.52,3.67-7.19,8.15-12.28,11.88-18.9,1.98-3.52,2.99-8.03,4.68-11.16.09-.17,2.42-1.35,2.88-2.52.59-1.52.18-3.32,0-4.86h.72Z"
          />

          <path
            class="cls-35"
            d="M108.38,115.94c.18,1.54.59,3.34,0,4.86-.46,1.17-2.79,2.35-2.88,2.52-1.69,3.14-2.7,7.64-4.68,11.16-3.73,6.62-8.21,11.72-11.88,18.9-.73-1.1-.41-2.97,0-4.14,2.25-6.39,11.51-15.13,14.76-22.68,1.88-4.37,2.6-9.77,4.32-13.68-.33,1.28.22,1.81.36,3.06Z"
          />

          <g>
            <path
              class="cls-8"
              d="M109.1,115.94h-.72c-.14-1.25-.69-1.78-.36-3.06-1.72,3.92-2.44,9.31-4.32,13.68-3.25,7.56-12.51,16.29-14.76,22.68-.41,1.17-.73,3.04,0,4.14-.25.5-.06,2.05-.9,2.52-.37-.23-.91-.25-1.26-.36-1.87-.57-4.81-3.32-6.84-4.14.46-20.83,16.2-32.13,28.62-46.27.94-.02.49,9.76.54,10.8Z"
            />

            <path
              class="cls-8"
              d="M93.08,131.78c.87,2.87.94,6.7-.36,9.36.02-.49-.54-1.53-.54-1.62,0-.14,1.07-2.38,1.08-2.52.1-2.27-.94-3.08-.18-5.22Z"
            />
          </g>
        </g>

        <g>
          <path
            class="cls-35"
            d="M59.05,102.62c-.74-.19-.68.35-.72.36-.31.09-.47-.6-.72-.18.77,5.2,1.4,11.64,1.08,16.92-.02.28-.7.08-.72.36-.13,1.77.21,4.11,0,5.76-.04.29-.68.07-.72.36-.1.68.38,3.92-.72,4.5-1.34-3.37-3.14-6.61-4.32-10.08,1.37-.93-3.14-20.44-3.96-18.9.22,2.5,1.42,5.06,1.8,7.56.15,1,.31,1.53.36,1.8.06.37-.54.89-.36,1.8.06.3.66.07.72.36.04.22-.9-.07-.72.9-2.17-5.12-4.67-10.85-6.12-16.2.57-1.79.25-7.12-1.8-7.74,1.19,1.43.79,3.85,1.08,5.22l-.72,1.62,7.56,21.6-11.52-6.12,12.24,7.2c1.11,3.39,2.04,6.92,3.24,10.26l-14.76-9.54,16.2,12.78c.66,1.98,1.17,4.11,1.8,6.12-.71.44-.09,1.06-1.26.36-.72-.43-11.19-9.54-12.42-7.02,2.41,1.01,4.9,2.27,7.02,3.78s6.79,6.94,8.1,7.56c.48.23.34.35.36.36.02,1.38.35,1.15-.9,1.44-.33.08-6.5.05-6.84,0-2.3-.34-6.44-3.52-8.46-1.8-12.47-19.3-4.46-51.16-16.2-69.31-2.71-4.18-6.67-7.61-9.72-11.52,14.86,12.06,30.69,23.89,42.13,39.43Z"
          />

          <path
            class="cls-8"
            d="M59.05,102.62c5.35,7.27,10.95,16.62,13.32,25.38,1.1,4.05.87,8.51,2.52,12.42-.21.76.44,1.89-.54,2.52-4.01-.78-10.64,5.57-13.14,1.44-.51-.84-.2-1.42-.36-1.8l6.12-16.02-7.2,13.14c-.8-2-1.37-4.15-2.16-6.12,3.02-9.45,2.9-20.89.72-30.61.04-.01-.02-.55.72-.36Z"
          />

          <path
            class="cls-35"
            d="M43.21,95.42c.21,1,.48,1.64.72,2.52,1.45,5.35,3.95,11.08,6.12,16.2.38,2.09,1.46,4.44,2.16,6.48,1.18,3.47,2.99,6.71,4.32,10.08.38.95.69,1.92,1.08,2.88.79,1.97,1.36,4.12,2.16,6.12.38.97.67,1.91,1.08,2.88.16.38-.15.96.36,1.8-.66-.09-1.57.14-2.16,0-.02,0,.12-.13-.36-.36-.44-1.57-.95-3.13-1.44-4.68-.63-2.01-1.14-4.14-1.8-6.12-.36-1.09-1.03-2.11-1.44-3.24-1.2-3.35-2.13-6.88-3.24-10.26l-12.24-7.2,11.52,6.12-7.56-21.6.72-1.62Z"
          />

          <path
            class="cls-8"
            d="M58.33,102.98c2.18,9.71,2.3,21.15-.72,30.61-.39-.96-.7-1.93-1.08-2.88,1.1-.58.62-3.82.72-4.5.04-.29.68-.07.72-.36.21-1.65-.13-3.99,0-5.76.02-.28.7-.08.72-.36.32-5.28-.31-11.72-1.08-16.92.25-.42.41.27.72.18Z"
          />

          <path
            class="cls-8"
            d="M52.21,120.62c-.7-2.04-1.78-4.39-2.16-6.48-.18-.97.76-.68.72-.9-.06-.29-.66-.07-.72-.36-.18-.91.42-1.43.36-1.8-.05-.27-.21-.81-.36-1.8-.38-2.5-1.58-5.06-1.8-7.56.82-1.53,5.33,17.98,3.96,18.9Z"
          />

          <path
            class="cls-8"
            d="M57.25,139.34c.49,1.55,1,3.11,1.44,4.68-1.31-.62-5.88-5.98-8.1-7.56s-4.62-2.77-7.02-3.78c1.23-2.52,11.7,6.59,12.42,7.02,1.17.7.55.08,1.26-.36Z"
          />

          <path
            class="cls-8"
            d="M54.01,129.98c.41,1.13,1.08,2.15,1.44,3.24l-16.2-12.78,14.76,9.54Z"
          />

          <path
            class="cls-8"
            d="M43.93,97.94c-.24-.88-.51-1.52-.72-2.52-.29-1.37.11-3.79-1.08-5.22,2.05.62,2.37,5.95,1.8,7.74Z"
          />

          <path class="cls-8" d="M60.85,142.58c-.41-.97-.7-1.91-1.08-2.88l7.2-13.14-6.12,16.02Z" />
        </g>

        <g>
          <path
            class="cls-8"
            d="M38.17,180.75c-3.08,1.88,2.32,5.14,0,6.48-8.28-3.51-16.5-7.07-24.84-10.44-1.14-.46-2.31-.9-3.42-1.44l.9-1.08c10.28,1.71,17.76,1.45,27.36,6.48Z"
          />

          <path
            class="cls-8"
            d="M47.17,187.23c.55.59,1.68,3.24,2.52,4.32-.96.27-1.02.37-1.98,0-3.17-1.21-6.38-2.98-9.54-4.32,2.32-1.34-3.08-4.6,0-6.48,3.11,1.63,6.61,3.93,9,6.48Z"
          />

          <g>
            <path
              class="cls-8"
              d="M10.8,174.27l-.9,1.08c1.11.54,2.28.98,3.42,1.44l39.25,17.28c-.29.12-1.02,1.03-1.08,1.08-6.79,1.71-14.63,2.26-21.78.36-2.15-.57-3.99-2.74-5.94-2.52-10.43-5.91-13.54-15.6-23.76-21.06,3.64.63,7.14,1.73,10.8,2.34Z"
            />

            <path
              class="cls-59"
              d="M51.49,195.15c-6.43,4.89-21.21,1.53-27.72-2.16,1.95-.22,3.79,1.95,5.94,2.52,7.15,1.9,15,1.35,21.78-.36Z"
            />

            <path
              class="cls-35"
              d="M38.17,187.23c3.17,1.34,6.38,3.11,9.54,4.32.96.37,1.02.27,1.98,0,.7.9,2.69,1.7,2.88,2.52l-39.25-17.28c8.34,3.37,16.57,6.93,24.84,10.44Z"
            />

            <path
              class="cls-59"
              d="M39.07,190.83c.39-.04,1.39.48,2.16,0,2.46,1.36-11.78,3.33-12.42,1.62,2.6-.83,5.48-.26,8.1-.54.12-.01,2.04-1.07,2.16-1.08Z"
            />
          </g>
        </g>

        <path
          class="cls-40"
          d="M24.84,155.19c-.79.23-.75.77-.72,1.44-.75.69-1.47-.78-1.8-1.26-1.35-1.97-2.52-4.21-3.96-6.12-1.01-1.34-7.43-8.43-7.56-9-.33-1.45.99-1.14.72-2.16-.07-.25-3.04-3.17-3.6-3.78,8.72,4.57,14.2,11.32,19.08,19.62l-.18,1.62c-2.44-5.87-7.33-10.59-12.42-14.22,4.76,4.13,7.68,8.23,10.44,13.86Z"
        />

        <path
          class="cls-37"
          d="M24.12,156.63c-.03-.67-.07-1.21.72-1.44.18.36,1.39,2.04,1.44,2.16.73,1.9,1.01,4.05,1.8,5.94-.32,1.17-3.52-1.27-3.96-1.62-5.69-4.54-11.72-14.32-14.76-20.88,4.81,6.37,9.2,13.14,14.94,18.72.7-.53-.16-2.5-.18-2.88Z"
        />

        <path
          class="cls-28"
          d="M29.88,164.55c-.98,1.68-2.01,1.58-3.6,2.16.2-.83-1.15-1-1.44-1.44-.41-.62-1.18-2.82-.72-3.6.44.35,3.64,2.79,3.96,1.62-.79-1.89-1.07-4.04-1.8-5.94l1.08-.9,2.52,8.1Z"
        />

        <g>
          <path
            class="cls-37"
            d="M214.96,203.43c-1.17,1.15-3.7.74-5.4.72-3.11-.03-6.09-.5-9.18.36-4.22,1.17-2.73,2.59-4.32,3.6-.69.44-7.14,4.01-7.56,3.96-1.68-.2-.11-3.38-3.06-1.08.82-2.09,2.94-4.08,4.68-5.4.71-.54,3.23-2.19,3.96-2.52.87-.4,3.4-1.28,4.32-1.44,5.73-1,11.07.35,16.56,1.8Z"
          />

          <path
            class="cls-83"
            d="M219.64,205.95c-2.1,6.41-12.15,13.77-18.36,16.02l14.76,1.08-14.04,2.34c-1.72-1.72-3.45-3.58-5.4-5.04,8.54-2.24,16.26-7.3,21.96-14.04.44-.16.94-1.05,1.08-.36Z"
          />

          <path
            class="cls-6"
            d="M219.64,205.95c-.14-.69-.64.2-1.08.36-1.64.6-3.66,1.97-5.76,3.24l-3.42,1.08c-.72-.56.32-3.17.18-3.42s-2.61.53-2.88-.72c.73-1.29,2.93-.62,2.88-2.34,1.7.02,4.24.43,5.4-.72,1.71.45,3.49.69,5.22,1.08.59.46-.5,1.33-.54,1.44Z"
          />

          <path
            class="cls-48"
            d="M183.27,212.79c-.31-.14-1.11-.23-1.44-.36,2.55-5.34,5.25-10.79,10.44-14.04l-9,14.4Z"
          />

          <path
            class="cls-83"
            d="M190.11,205.59c-1.74,1.32-3.86,3.31-4.68,5.4-.76.59-1.22,1.42-1.8,2.16-.48-.21-.34-.35-.36-.36l9-14.4c.31-.2,2.18-1.86,2.52-.9l-4.68,8.1Z"
          />

          <path
            class="cls-34"
            d="M198.39,201.63c-.92.16-3.45,1.04-4.32,1.44.26-1.39,6.35-9.16,7.2-7.74l-2.88,6.3Z"
          />

          <path
            class="cls-28"
            d="M209.55,204.15c.05,1.72-2.15,1.05-2.88,2.34.27,1.25,2.74.47,2.88.72s-.9,2.86-.18,3.42l3.42-1.08c-5.92,3.58-11.6,7.02-18,9.72-3.25-2.21-7.56-4.53-11.16-6.12.58-.74,1.04-1.57,1.8-2.16,2.95-2.3,1.38.88,3.06,1.08.42.05,6.88-3.52,7.56-3.96,1.59-1.01.1-2.43,4.32-3.6,3.1-.86,6.07-.39,9.18-.36Z"
          />

          <path
            class="cls-48"
            d="M218.56,206.31c-5.7,6.74-13.42,11.81-21.96,14.04-.47-.35-1.23-.69-1.8-1.08,6.4-2.7,12.08-6.14,18-9.72,2.1-1.27,4.12-2.64,5.76-3.24Z"
          />
        </g>

        <g>
          <path
            class="cls-72"
            d="M182.91,164.55c-1.38,1.97-5.92,2.42-6.12,3.06,1.2,2.17,3.17,2.74,5.4,2.52-2.51,3.52-4.15-1.14-6.12,1.44,2.9.69,4.54,1.34,7.2-.54-.47.73-1.21,2.39-2.52,2.88-.35.13-4.28.42-4.5.36-1.3-.33-3.04-2.73-3.42-2.88-.94-6.21,5.74-6.66,8.64-10.44,3.35-.84,2.79,1.69,1.44,3.6Z"
          />

          <path
            class="cls-56"
            d="M185.79,166.71c-1.46,1.01-1.63,2.93-2.52,4.32-2.66,1.88-4.3,1.23-7.2.54,1.97-2.58,3.61,2.08,6.12-1.44-2.23.22-4.2-.35-5.4-2.52.2-.64,4.74-1.09,6.12-3.06,1.49-.29,2.11,1.6,2.88,2.16Z"
          />

          <path
            class="cls-56"
            d="M176.25,168.51c.33,0,1.48,1.43.36,1.8-1.67.54-1.22-1.81-.36-1.8Z"
          />
        </g>

        <path
          class="cls-2"
          d="M20.52,163.83c-5.75-4.97-10.03-12.36-12.24-19.62-.17-.58-1.07-3.15,0-3.42,2.78,6.72,6.48,13.27,11.52,18.54l-2.7-1.62c-1.17,1.77,4.6,5.56,4.5,5.94s-.9.07-1.08.18Z"
        />

        <g>
          <path
            class="cls-19"
            d="M77.41,243.4c-.07,5.48,2.09,12.06,4.5,16.92.85-.04-.94-15.18-.9-16.92h2.52c-.12,5.45,1.64,9.11,2.52,14.04,1,5.58,2.1,11.12,2.88,16.74,1.52.66.84-.45,1.08-1.62.48-2.34.46-4.51.72-6.84l1.08.9c1.75-6.44,3.63-12.83,5.4-19.26l2.16.36c-1.38,6.42-3.02,13.05-3.78,19.44,3.19-5.97,7.59-11.99,9.9-18.36l3.24,1.44c-.06.19.06.54,0,.72-.65,1.89-1.96,4.89-2.88,6.66-1.01,1.94-6.85,9.32-7.02,9.9-.11.37.19.74.36,1.08,4.85-5.26,14.45-12.76,16.38-19.8l3.96,1.44c-3.25,8.74-10.55,16.27-17.46,22.32-4.98,4.36-11.4,6.58-14.04,13.32.03-8.42-5.78-15.13-8.82-22.5-2.44-5.91-4.84-13.56-5.04-19.98h3.24Z"
          />

          <path
            class="cls-75"
            d="M173.19,165.99c.54.83-2.25,3.77-1.08,5.4-2.95.11-17,6.63-20.52,8.28-4.46,2.09-10.52,4.66-14.4,7.56l-1.44.36c.13-.79-.39-.9,0-1.62,1.31-2.4,6.52-5.19,8.28-7.56-2.19-.66-9.41,5.88-10.26,5.58-3.36-1.16,5.13-8.02,6.3-8.46l-7.2,4.14c-.1-.2-1.43-.41-1.44-1.08.29-.43.69-.66,1.08-1.44,4.13-4.75,8.38-7.99,14.4-9.72,1.2-.35,2.48.59,3.06-1.08l9-.36c-.06-.2-.83-1.06-.9-1.08l.72-.36c.56,1.73,3.95,4.67,5.94,4.68l-2.16-2.52c1.34,1.4,4.43,1.66,6.3.9-1.67-.27-7.22-2.02-6.12-3.78,1.7-.84.06-.31,0-.36-1.58-1.34-1.35-1.76.18-3.6,1.66,5.91,3.8,8.47,10.26,6.12Z"
          />

          <path
            class="cls-69"
            d="M131.78,197.31c-1.21.65-2.53.83-3.6,1.62-.26.9,2.76,1.92,3.24,1.98,4.03.51,10.8-2.39,14.76-3.6.11-.03.25.03.36,0-1.95,2.48-5.14,3.56-7.56,5.4-.72.54-1.58.89-2.16,1.62.82,1.31,1.71.72,2.88.9.63.1,1.61.66,2.52.36-.28.1-1.05,1.31-2.34.72l.36.72c-.58.75-11.3-3.32-10.62-1.98,2.14.77,4.04,2.08,6.12,3.06l.18,1.08-5.94-.72c-.66-.16-2.52-.99-3.06-.72,2.44,1.67,5.45,3.21,8.1,5.04,1.91,1.32,3.62,2.84,5.4,4.32l-.36.72c-1.67-1.31-2.93-2.11-4.68-3.24-3.56-2.31-7.71-5.28-11.88-5.58-.4.5.84,1.61,1.08,1.98,1.75,2.74,4.98,5.34,6.66,7.92.76,1.17.46.66-.54.72-1.19-1.33-2-2.05-3.24-3.24-1.37-1.32-2.68-2.73-4.14-3.96l-.9.18c2.1,5.81,3.6,11.65,5.76,17.46,1.69,4.53,3.68,8.96,5.76,13.32.3.62,1.3,1.35.9,2.16-.74-.45-.85-1.23-1.26-1.8-4.47-6.19-7.11-13.37-10.08-20.34l-.9-.54-.54,1.8c-.89-3.43-4.36-11.29-6.84-13.68-.16-.15-.45-1.12-.54-1.08-.42.18.15,1.6-.54,1.26-.71-1.17-1.41-3.12-2.16-4.14-1.84-2.48-1.73-2.94-5.04-2.16.25-.73.31-1.39.36-2.16.75.36,2.21-.38,2.52-.36.07,0-.56.31.72.36.12,0,.24,0,.36,0,2.79.03,5.69-.19,8.46,0,1.59.11,9.23,1.88,9.72,1.8.1-.02.66-.46.36-.72-.28-.24-6.2-1.99-7.02-2.16l-2.52-1.26c1.69-.23,4.6-1.75,5.94-2.7.74-.52,3.24-2.94,4.5-3.96,2.83.73-1.12,2.47,2.52,1.44,2.44-.69,4.43-1.99,6.84-2.34-2.55,1.65-5.25,3.06-7.92,4.5Z"
          />

          <path
            class="cls-63"
            d="M168.87,256c-1.36-2.4-6.44-6.68-8.28-9.18-3.86-5.25-6.92-10.03-11.16-15.3-2.95-3.66-5.85-7.32-9-10.8l1.08-1.44,6.12,4.68c.55.73,2.1,1.61,2.88,2.7,4.85,6.75,8.52,14.39,13.5,21.06,1.15-4.98-13.47-27.56-16.92-27l-.9.9c.67.34.55.88.72,1.26-1.47-.89-2.38-2.47-3.6-3.6l2.16-2.52c.08.05.28-.05.36,0l-.18,2.52.9-1.8,5.04,3.06c-1.77-2.34-5.26-3.88-6.12-6.66,2.58,1.41,5.31,2.46,7.38,4.68-.24-1.47-2.89-3.07-4.14-3.96l.72-2.16c2.13,1.33,8.27,7.01,7.92,9.54-.08.58-1.09-1.2-1.08,0,3.13,4.87,7.95,12.54,9.72,18,.11.34-.75,1.71-.72,1.8,1.4,4.6,3.97,9.15,3.6,14.22Z"
          />

          <path
            class="cls-69"
            d="M92.18,172.83c.76,1.01,1.26,2.11,1.8,3.24.5,1.04.86,2.81,1.26,3.96.87-1.54.07-4.83-.18-6.66,2.58.34,2.06,2.36,2.52,3.78.37,1.12.34,2.87,2.52,2.88-.35.64.34,1.68.36,1.8.57,4.01.3,1.33,2.52,3.24l3.6,11.16-4.86-5.4,2.34,5.58c-.29.75-5.28-.1-6.48-.18.46-1.71-2.95-1.4-3.96-1.08-1.48-1.82-1.91-1.61-3.6-2.88-2.26-1.7-4.67-3.22-6.84-5.04-3.78-3.17-7.49-6.61-10.62-10.44,4.31,3.04,8.69,6.76,13.5,9-1.4,1.4,5.46,2.93,5.76,2.7.8-.61-.52-2.85,3.06-.54.89-1.7-.44-2.64-.9-3.96-.58-1.67-1.19-3.38-1.8-5.04-1.05-2.84-.79-6.75-4.14-7.92l1.26-.72c.59.41,2.52,2.05,2.88,2.52Z"
          />

          <path
            class="cls-63"
            d="M73.45,193.35c-2.05,4.85-10.67,4.62-14.76,7.74,3.56-1,7.17-1.64,10.8-2.34l2.16.18c.77.94-19.06,9.15-19.8,11.52-.18.69,1.03.24,1.26.18,3.89-1.08,9.79-5.49,14.22-6.84,1.18-.36,8.2-1.99,8.64-1.26l-17.28,10.62c-.35,0-.39.39-.72.36.12-.44.23-.98.36-1.44.14-.49.83-.69.54-1.08-11.93,2.62-8.64-1.64-2.52-7.56-1.46.33-3.99,1.11-5.22,1.8-1.27-.06-2.22-.36-2.88-1.44,1.69-1.17,3.27-2.21,5.04-3.24,2.15-1.24,3.24-.12,2.52-3.6,5.29-1.89,12.04-3.1,17.64-3.6Z"
          />

          <path
            class="cls-63"
            d="M180.75,173.91c1.82,1.53-.25,4.54-.72,6.12-2.03-.76-1.34,1.37-2.16,2.88-.64-1.17-1.14-.09-2.16.72-.15-.43-.78-1.17-1.26-1.08-.6.11-7.85,6.01-9.9,7.2-.5.29-1.05.5-1.44.72-1.26-.4-2.37-2.55-2.52-3.96,2.11-1.31,15.66-9.96,15.84-11.34-.13-1.07-.48-.41-.9-.18-4.3,2.36-9.38,6.57-14.22,9.36l-2.52-6.3,13.68-6.66c.13.02.27-.03.36,0,.38.15,2.12,2.55,3.42,2.88.22.06,4.15-.23,4.5-.36Z"
          />

          <path
            class="cls-19"
            d="M168.87,256c1.26,2.23,1.59,6.22,3.06,8.64-2.92-2.89-6.81-3.72-10.62-4.68.14-.76-.72-1.2-1.26-1.44-4.62-2.03-9.14-3.47-13.5-6.12l1.44-2.88c2.37,1.52,9.69,5.84,12.06,6.48.67.18,1.05.69,1.62-.18-5.47-3.84-10.14-8.37-14.76-13.14l1.08-1.8c1.99,2.09,5.09,3.58,7.02,5.4.44.41-1.04.44-.54.9,2.43,2.27,5.06,4.27,7.56,6.48l1.08-.36c-5.2-6.86-10.02-14.04-15.48-20.7l1.8-1.08c4.24,5.27,7.3,10.05,11.16,15.3,1.84,2.5,6.92,6.78,8.28,9.18Z"
          />

          <path
            class="cls-41"
            d="M81.73,218.92c-.32.75-2.36,1.82-1.62,2.52,1.14-.7,2.06-1.66,3.06-2.52l1.44,2.88c-3.27,2.84-5.49,5.73-9.36,8.28-10.67,7.04-16.95,5.99-28.8,7.56-.35-1.21,1.19-1.27,1.98-1.44,5.72-1.23,12.92-1.98,16.38-7.2,2.79-1.46,4.14-2.26,5.76-5.4,2.64-1.72,4.71-3.97,7.2-5.76.63-.45,1.22-1.01,1.8-1.44.33-.25.74-.48,1.08-.72.99,1.29,1.82,1.53,1.08,3.24Z"
          />

          <path
            class="cls-19"
            d="M44.29,225.76c-.03.11.01.24,0,.36l-9.36,9.18,8.28-4.86,2.52,1.26-2.7,1.62-.36,1.08c.33.17,6.42-1.29,7.38-1.44,5.61-.87,9.55-1.23,14.76-3.96-3.46,5.22-10.66,5.97-16.38,7.2-.79.17-2.33.23-1.98,1.44-10.11,1.34-14.93,2.88-20.34,12.24.49-4.33,1.28-8.66,1.98-12.96h.72c-.62,2.5-.7,6.01-1.26,8.64,3.5-4.6,5.83-10.99,9.54-15.3,1.5-1.75,4.6-5.32,7.2-4.5Z"
          />

          <path
            class="cls-41"
            d="M146.54,252.4c4.37,2.65,8.89,4.09,13.5,6.12.54.24,1.4.68,1.26,1.44-11.94-3.01-24.63-2.39-33.13-12.96,1.35.62,1.34-1.09,2.88-2.16.32-.23,1.99-.8,2.52-1.08.41.57.52,1.36,1.26,1.8.4-.81-.6-1.54-.9-2.16,2.6-.26,5.46,4.03,7.74,5.76,1.5,1.14,3.25,2.26,4.86,3.24Z"
          />

          <path
            class="cls-41"
            d="M88.93,226.12c-2.74,4.47-5.29,12.05-5.4,17.28h-2.52c.1-3.94.97-8.01,1.62-11.88-3.78,2.28-5.17,7.69-5.22,11.88h-3.24c-.09-2.9.4-10.2,1.8-12.6.88-1.52,11.44-9.95,13.68-11.88-.57,2.29-3.13,3.78-4.32,5.94-4.36,7.92-.26,4.62,3.6,1.26Z"
          />

          <path
            class="cls-72"
            d="M174.99,157.71c-2.16,1.95-7.53,1.97-7.92,3.06-.87,2.43,1.87,1.81,2.16,2.16s-1.53,1.34-.18,1.98c.68.32,4.15-.21,4.14,1.08-6.46,2.35-8.61-.21-10.26-6.12-1.53,1.84-1.76,2.26-.18,3.6v.36c-1.1,1.76,4.46,3.51,6.12,3.78-1.88.76-4.96.5-6.3-.9l2.16,2.52c-1.99-.01-5.38-2.95-5.94-4.68-1.29-3.99,2.69-9.18,6.48-10.08,2.22-.53,3.84,1.05,5.94,1.08l-1.26,1.26c.58,1.13,6.3-4.7,6.84-1.08-.72.49-1.19,1.42-1.8,1.98Z"
          />

          <path
            class="cls-56"
            d="M77.77,152.67l.54,1.8c-3.02-.6-5.98-.49-9-.72-.26-.02-.1.74-.36.72-.36-.03-5.39-2.1-5.58-1.62,4.05,2.53,8.32,4.23,12.24,7.02-.05.03-.12.69-.9.72-.48.02-7.84-3.11-9-3.6-5.87-2.48-9.64-4.41-16.02-6.48-1.33-.43-1.55-.74-2.16-1.08.17-.14.24-.24.36-.36,10.42.63,20.14-.18,29.88,3.6Z"
          />

          <path
            class="cls-41"
            d="M160.59,194.79l-6.48,7.74c.32.42,2.39-.02,2.88-.18-.9,1.59-2.05.99-.36,2.88-.82.43-2.54,1.09-1.8,1.8-2.88.07-5.86,1-9,1.08v-2.16c.1-.05,1.77-1.14,1.62-1.44-1.46.29-3.08.31-4.5.72-.66.19-.68.35-.72.36-.91.3-1.89-.26-2.52-.36l2.52-1.8c2.61-1.03,7.87-4.58,11.16-6.12,2.02-.95,5.07-1.45,7.2-2.52Z"
          />

          <path
            class="cls-71"
            d="M70.57,181.11c1.4,1.02,11.26,7.51,12.06,7.56.67.04.9-.87.54-1.44,2.17,1.82,4.58,3.34,6.84,5.04-2.25,2.02-7.48-3.08-9,.72-.48,0-.96,0-1.44,0-2.48-.58-5.05-.3-7.56-.72-1.05-.18-3.14-.78-4.32-1.08l.54-.72c-.68-.1-1.3-.26-1.98-.36-.12-.02-.24.02-.36,0-2.59-.41-.32-1.67-.72-2.7-.28-.73-1.9-.48-1.98-.54-.7-.51-1.23-1.32-1.98-1.8l.36-.36c.18.1.89-.1,1.08,0,3.77,2.07,12.8,6.31,17.46,6.48,5.05.19-.69-2.63-2.7-3.24-6.89-4.37-12.46-9.19-17.64-15.48l10.8,8.64Z"
          />

          <path
            class="cls-68"
            d="M47.89,149.06c-.12.12-.19.22-.36.36-.04.04-.94-1.09-1.08.18.4.59.86-.3,1.08-.18.61.34.83.65,2.16,1.08l-.72,1.08c-.45-.2-1.8-1.05-1.98-1.08-1.65-.3-1.19.72-1.26.72-.47,0-.04-.33-1.08,0-.47.15-.14-.95-1.44.36-.13.13-.82-.43-.72.9,1.91,2.74,2.42,6.2,3.6,9.18l-1.08.54c1.99,6.9,4.75,12.68,9.36,18.18-1.17-.87-4.66-2.56-6.12-4.32-6.1-7.35-6.65-21.84-7.74-30.97,2.56,1.88,4.87,2.15,7.92,2.52.17.2-.38,1.28-.54,1.44Z"
          />

          <path
            class="cls-63"
            d="M180.03,180.03c-4.38,14.69-10.56,18.44-23.4,25.2-1.69-1.89-.54-1.29.36-2.88,6.01-1.92,17.83-13.84,20.88-19.44.82-1.51.13-3.64,2.16-2.88Z"
          />

          <path
            class="cls-19"
            d="M40.33,214.96c-1.26,1.49-1.86,2.79-2.88,4.32-1.09,1.63-4.29,5.4-3.24,7.2-.9,1.32-1.6,4.42-2.88,6.3-.21.31-.92-.62-1.44,0-.14.16-.94,3.56-1.08,4.14h-.72c1.98-12.21,1.17-12.69,9-22.32,1.93.18,1.93-1.37,3.24.36Z"
          />

          <path
            class="cls-30"
            d="M77.77,152.67l10.08,3.96c1.13.92,2.08,2.01,3.24,2.88-.06.04-.66,1.08-.9,1.08-.82,0-9.34-5.85-11.52-5.76-.6.76.74.83,1.26,1.08.13,1.04-1.16,2.25.36,2.7-.97,0-1.54,0-2.52.18-2.79.52-1.64.81-2.16,1.08-3.93-2.79-8.19-4.49-12.24-7.02.19-.48,5.23,1.59,5.58,1.62.26.02.1-.74.36-.72,3.02.23,5.99.12,9,.72l-.54-1.8Z"
          />

          <path
            class="cls-41"
            d="M121.7,236.92c.1,5.47-.26,8.22-2.16,13.32l-3.96-1.44c.62-2.26,1.59-10.66,1.8-13.32.07-.9.36-1.02.36-1.08.6.13,2.8-.18,3.06,0,.6.42-.48,4.38.9,2.52Z"
          />

          <path
            class="cls-71"
            d="M115.22,210.99c.93,4.96,3.9,9.3,5.04,14.22.79,3.39,1.37,8.23,1.44,11.7-1.38,1.86-.3-2.1-.9-2.52-.26-.18-2.46.13-3.06,0,.08-1.66-.19-2.78-.36-4.32,1.63.38.51-4.54.36-5.22-1.27-5.96-4.66-11.78-5.76-17.82.75,1.02,1.45,2.97,2.16,4.14.69.34.12-1.08.54-1.26.09-.04.38.93.54,1.08Z"
          />

          <path
            class="cls-71"
            d="M133.58,243.76c-.53.28-2.2.85-2.52,1.08-2.18-2.28-4.22-4.75-5.4-7.74-1.01-2.55-.93-5.86-2.52-8.1-.18-1.51-.7-2.87-1.08-4.32l.54-1.8.9.54c2.97,6.97,5.61,14.15,10.08,20.34Z"
          />

          <path
            class="cls-71"
            d="M77.77,158.79l14.04,8.28c.06.7.05,1.21-.36,1.8-.07-.1-2.02-2.14-2.16-.9l2.88,2.34c.15.43.36,2.02,0,2.52-.36-.47-2.29-2.11-2.88-2.52-2.3-1.62-2.97-1.2-3.42-1.44-1.71-.91-3.13-2.36-4.86-3.24-.28-.33.54-.97.36-1.26-.53-.86-2.78-2.01-3.6-2.7-.77-.64-1.26-1.16-2.16-1.8.52-.27-.63-.56,2.16-1.08Z"
          />

          <path
            class="cls-14"
            d="M54.37,180.39c1.39,1.04,2.01,2.15,3.06,2.88.98.68,2.94,1.26,3.78,1.8.75.48,1.29,1.29,1.98,1.8.08.06,1.7-.19,1.98.54.4,1.03-1.87,2.29.72,2.7-4.31-.71-4.98-1.28-8.82-2.88-.56-.23-1.72-.89-1.62.36-.48-3.65-6.11-7.34-7.2-11.52,1.46,1.76,4.95,3.45,6.12,4.32Z"
          />

          <path
            class="cls-41"
            d="M91.46,164.19c.02,1.16.28,1.99.36,2.88l-14.04-8.28c.98-.18,1.55-.17,2.52-.18-1.52-.45-.23-1.66-.36-2.7,6.26,3,6.01,4.1,10.44,8.46.96.95.38.18,1.08-.18Z"
          />

          <path
            class="cls-71"
            d="M81.01,192.99c3.32.54,7,.47,10.26,1.44.71.21,1.53.42,1.26,1.44-4.73-.64-10.98-3.04-15.12-.9,1.13.58,4.28-.55,4.5,1.26-1.77-.48-4.7-.59-6.48-.36-.19.03-3.75,1.22-3.42,1.8-.74.11-2.35,1.05-2.52,1.08-3.63.7-7.24,1.34-10.8,2.34,4.09-3.12,12.71-2.89,14.76-7.74,1.61-.14,5.19-.36,6.12-.36.48,0,.96,0,1.44,0Z"
          />

          <path
            class="cls-63"
            d="M48.25,203.79c.66,1.08,1.61,1.38,2.88,1.44-2.25,1.26-9.02,7.61-10.8,9.72-1.31-1.73-1.31-.18-3.24-.36,4.08-5.01,5.72-7.03,11.16-10.8Z"
          />

          <path
            class="cls-71"
            d="M142.22,205.59s.06-.17.72-.36c.05,1.92,1.5,1.37,2.88.72v2.16c-.72.02-2.08-.29-2.52.36-1.24-.34-2.52-1.42-3.6-.54,2.99,1.78,6.69,2.6,9.72,4.5l-.72,2.16c-4.44-3.16-8.27-4.26-12.96-6.48-2.08-.98-3.99-2.29-6.12-3.06-.68-1.34,10.04,2.73,10.62,1.98l-.36-.72c1.29.59,2.06-.62,2.34-.72Z"
          />

          <path
            class="cls-63"
            d="M89.65,218.92c-2.24,1.94-12.8,10.36-13.68,11.88l-.72-.72c3.87-2.56,6.09-5.44,9.36-8.28.45-.39.79-.83,1.08-1.08,2.59-2.23,4.89-4.67,7.56-6.84,2-1.62,4.69-3.67,6.84-5.04.96-.62,1.87-1.25,2.88-1.8-4.15,4.21-8.84,8.01-13.32,11.88Z"
          />

          <path
            class="cls-49"
            d="M131.06,244.84c-1.84.39-6.19-6.51-6.66-6.48.13.42-.19,1.37-.18,1.44-2.08-2.94-.66-7.33-1.08-10.8,1.59,2.24,1.51,5.55,2.52,8.1,1.18,2.99,3.22,5.46,5.4,7.74Z"
          />

          <path
            class="cls-63"
            d="M53.29,200.55c-.46-1-4.86,1.04-5.58,1.44-2.05,1.13-3.63,3.45-5.94,3.78,4.14-3.8,8.75-6.93,14.04-8.82.72,3.48-.38,2.36-2.52,3.6Z"
          />

          <path
            class="cls-71"
            d="M91.09,159.51c.1-.06.5.03.72,0-.2,1.68-.41,2.49-.36,4.68-.7.36-.12,1.13-1.08.18-4.43-4.37-4.18-5.46-10.44-8.46-.52-.25-1.86-.32-1.26-1.08,2.18-.08,10.71,5.76,11.52,5.76.24,0,.84-1.04.9-1.08Z"
          />

          <path
            class="cls-71"
            d="M131.06,244.84c-1.54,1.07-1.53,2.78-2.88,2.16-1.27-1.58-3.81-5.22-3.96-7.2,0-.07.31-1.02.18-1.44.47-.03,4.83,6.87,6.66,6.48Z"
          />

          <path
            class="cls-19"
            d="M158.07,164.91c.07.02.84.88.9,1.08l-9,.36c-.58,1.67-1.86.73-3.06,1.08v-1.08c1.81-.51,2.36-1.41,2.52-1.44.82-.14,8.06-.17,8.64,0Z"
          />

          <path
            class="cls-69"
            d="M91.46,168.87c.23.34.59,1.05.72,1.44l-2.88-2.34c.14-1.24,2.09.8,2.16.9Z"
          />

          <path
            class="cls-30"
            d="M109.1,212.79c.28,1.7.31,5.29.36,7.2.14,4.79-.15,9.31-.72,14.04s-1.56,10.15-3.24,14.76c-2.32,6.38-6.71,12.4-9.9,18.36.76-6.4,2.4-13.02,3.78-19.44,1.18-5.49,2.22-11.13,3.6-16.56,1.3-5.12,3.25-12.2,5.04-17.1.19-.52.38-1.45,1.08-1.26Z"
          />

          <path
            class="cls-56"
            d="M92.54,245.56c-.8,6.68-1.04,13.46-1.8,20.16-.26,2.33-.24,4.5-.72,6.84-.32-6.79-2.52-13.89-2.16-20.7.26-4.95,2.21-16.5,3.96-21.06.88-2.3,2.31-5.36,4.32-6.84-1.58,7.12-2.73,14.36-3.6,21.6Z"
          />

          <path
            class="cls-41"
            d="M117.38,230.08c.17,1.54.44,2.66.36,4.32,0,.06-.29.18-.36,1.08l-8.64,15.48c.06-.18-.06-.53,0-.72,1.76-5.42,2.78-10.48,3.24-16.2.5-6.19-.05-10.29-.36-16.2-.09-1.73.07-3.49,0-5.22,2.47,4.77,5.13,11.89,5.76,17.46Z"
          />

          <path
            class="cls-56"
            d="M117.38,235.48c-.21,2.66-1.18,11.06-1.8,13.32-1.93,7.04-11.53,14.54-16.38,19.8-.17-.34-.47-.71-.36-1.08.17-.58,6.01-7.96,7.02-9.9.92-1.77,2.23-4.77,2.88-6.66l8.64-15.48Z"
          />

          <path
            class="cls-30"
            d="M90.37,230.8c-2.88,9.05-4.09,17.1-4.32,26.64-.88-4.93-2.64-8.59-2.52-14.04s2.66-12.81,5.4-17.28c1.11-1.81,2.66-3.07,3.96-4.68.49,2.74-1.58,6.41-2.52,9.36Z"
          />

          <path
            class="cls-19"
            d="M99.02,240.52c-.61,2.27-1.18,4.58-1.8,6.84-1.77,6.43-3.65,12.83-5.4,19.26l-1.08-.9c.76-6.7,1-13.49,1.8-20.16,1.97,1.27,1.9-4.69,2.16-6.12l4.32,1.08Z"
          />

          <path
            class="cls-63"
            d="M81.01,243.4c-.04,1.74,1.75,16.89.9,16.92-2.41-4.86-4.57-11.44-4.5-16.92.05-4.19,1.44-9.61,5.22-11.88-.65,3.88-1.52,7.94-1.62,11.88Z"
          />

          <path
            class="cls-14"
            d="M91.82,230.8c-1.75,4.56-3.7,16.12-3.96,21.06-.36,6.81,1.84,13.91,2.16,20.7-.24,1.17.44,2.28-1.08,1.62-.78-5.62-1.88-11.17-2.88-16.74.23-9.55,1.44-17.59,4.32-26.64h1.44Z"
          />

          <path
            class="cls-41"
            d="M111.98,234.04c-.46,5.72-1.48,10.78-3.24,16.2l-3.24-1.44c1.68-4.62,2.65-9.88,3.24-14.76h3.24Z"
          />

          <path
            class="cls-41"
            d="M102.98,231.16c-1.38,5.43-2.42,11.07-3.6,16.56l-2.16-.36c.62-2.26,1.19-4.57,1.8-6.84.87-3.23,1.67-6.48,2.52-9.72l1.44.36Z"
          />

          <path
            class="cls-41"
            d="M172.47,171.39l-13.68,6.66,2.52,6.3c-7.77,4.48-16.67,9.32-25.02,12.6-.68.27-5.03,2.38-4.5.36,2.67-1.44,5.37-2.85,7.92-4.5-2.41.35-4.4,1.65-6.84,2.34l18.54-13.32.18-2.16c3.52-1.65,17.57-8.17,20.52-8.28.11,0,.25-.02.36,0Z"
          />

          <path
            class="cls-69"
            d="M135.74,187.59l1.44-.36c-2.09,1.56-4.59,4.66-6.84,6.48-1.26,1.02-3.76,3.44-4.5,3.96-1.34.95-4.25,2.47-5.94,2.7l2.52,1.26c-1.63-.33-3.63-.78-5.22,0l.72-1.44c-1.35-.32-2.78,1.01-3.78-.36.8-.76,2.16-2.17,2.52-3.24.77-.71,1.63-.76,2.52-2.16,3.19-.94,5.22-1.53,6.12-5.04.84-.33,2.23-1.58,3.24-2.16,1.55-.89,3.19-2.52,5.04-2.7l-7.02,7.02,9.18-3.96Z"
          />

          <path
            class="cls-71"
            d="M135.74,187.59l-9.18,3.96,7.02-7.02c-1.85.18-3.49,1.81-5.04,2.7l-1.08-.36c1-1.09,1.68-3.27,1.8-3.42,1.04-1.23,4.38-2.22,3.6-3.78l7.2-4.14c-1.17.44-9.66,7.3-6.3,8.46.85.3,8.07-6.24,10.26-5.58-1.76,2.37-6.97,5.16-8.28,7.56-.39.72.13.83,0,1.62Z"
          />

          <path
            class="cls-71"
            d="M151.58,179.67l-.18,2.16-18.54,13.32c-3.64,1.03.31-.71-2.52-1.44,2.25-1.82,4.75-4.92,6.84-6.48,3.88-2.9,9.95-5.47,14.4-7.56Z"
          />

          <path
            class="cls-41"
            d="M146.9,166.35v1.08c-6.02,1.73-10.27,4.98-14.4,9.72.1-.19,1.41-3.75,1.44-3.96,4.31-3.96,7.38-5.28,12.96-6.84Z"
          />

          <path class="cls-61" d="M162.75,163.83v-.36c.06.05,1.7-.48,0,.36Z" />

          <path
            class="cls-41"
            d="M147.62,232.6c5.46,6.66,10.28,13.84,15.48,20.7l-1.08.36c-2.5-2.21-5.13-4.22-7.56-6.48-.5-.46.98-.49.54-.9-1.94-1.82-5.03-3.31-7.02-5.4-6.27-6.6-11.24-14.48-17.28-21.24,1-.06,1.3.45.54-.72-1.68-2.58-4.91-5.18-6.66-7.92-.13-1.23,1.12-.61,1.62-.36,5.64,2.84,17.04,16.62,21.42,21.96Z"
          />

          <path
            class="cls-71"
            d="M160.59,186.51c-4.8,2.98-9.59,5.95-14.76,8.28l-14.4,6.12c-.48-.06-3.5-1.08-3.24-1.98,1.07-.79,2.39-.97,3.6-1.62-.53,2.02,3.83-.09,4.5-.36,8.35-3.28,17.25-8.12,25.02-12.6,4.84-2.79,9.92-7,14.22-9.36.42-.23.77-.89.9.18-.18,1.38-13.74,10.03-15.84,11.34Z"
          />

          <path
            class="cls-49"
            d="M111.98,207.03c1.1,6.04,4.49,11.86,5.76,17.82.15.68,1.27,5.6-.36,5.22-.63-5.58-3.29-12.69-5.76-17.46.07,1.73-.09,3.49,0,5.22l-2.16,2.16c-.05-1.91-.08-5.5-.36-7.2-.32-2-1.4-.22-1.8-1.26s.41-3.34.18-4.5c-.96-.54-2.97,4.8-3.6,5.04-.58.22-.84-.71-.9-.72.91-1.86,3.07-3.59,2.88-5.76.06-.02.63-.61,1.08-.72,3.31-.78,3.2-.32,5.04,2.16Z"
          />

          <path
            class="cls-71"
            d="M147.98,249.52l-1.44,2.88c-1.61-.98-3.36-2.1-4.86-3.24-2.28-1.73-5.14-6.02-7.74-5.76-2.08-4.36-4.07-8.79-5.76-13.32l.36-1.08c3.64,7.71,12.33,15.96,19.44,20.52Z"
          />

          <path
            class="cls-71"
            d="M135.38,214.6c.72,2.3,3.41,4.32,5.04,6.12,3.16,3.49,6.05,7.14,9,10.8l-1.8,1.08c-4.38-5.35-15.78-19.12-21.42-21.96-.5-.25-1.75-.87-1.62.36-.24-.37-1.48-1.48-1.08-1.98,4.18.3,8.32,3.28,11.88,5.58Z"
          />

          <path
            class="cls-71"
            d="M130.7,219.64c6.04,6.76,11.01,14.65,17.28,21.24l-1.08,1.8c-5.67-5.86-10.5-12.12-15.48-18.54-.21-.27-1.66-2.51-2.16-1.62-.74-1.72-2.58-4.21-1.8-6.12,1.25,1.19,2.05,1.91,3.24,3.24Z"
          />

          <path
            class="cls-41"
            d="M163.11,190.47c-3.36,1.85-6.5,3.3-10.08,4.68-2.19.84-4.25,1.46-6.48,2.16-.11.03-.25-.03-.36,0l-.36-2.52c5.17-2.34,9.96-5.3,14.76-8.28.15,1.41,1.26,3.56,2.52,3.96Z"
          />

          <path
            class="cls-53"
            d="M99.02,197.31c2.84,1.32,5.47,2.95,8.28,4.32,0,.34,0,1.03,0,1.08-.05.77-.11,1.43-.36,2.16-.45.11-1.02.7-1.08.72-1.14.42-1.84.87-2.88,1.44s-1.92,1.18-2.88,1.8l1.8-2.7-3.24-1.8,1.8-1.08c.07-1.04-1.4-.2-1.8-.72-.65-.85,3.14-2.45-3.6-3.42l.18-2.52,3.78.72Z"
          />

          <path
            class="cls-49"
            d="M127.46,216.4c-.78,1.91,1.06,4.4,1.8,6.12,1.56,3.6,3.13,7.19,5.04,10.62l-7.02-10.26c-1.19.03.94,5.44,1.26,6.12l-.36,1.08c-2.16-5.81-3.66-11.65-5.76-17.46l.9-.18c1.46,1.23,2.77,2.64,4.14,3.96Z"
          />

          <path
            class="cls-71"
            d="M129.98,208.47c1.3.31,2.14.83,3.06,1.08.72.2,1.01-.46,1.44-.36.37.09-.58.91,0,1.08.45.13,2.64-.76,2.88-.72,1.96.33,6.19,3.27,8.1,4.32.86,2.78,4.35,4.32,6.12,6.66l-5.04-3.06c0-.44-.44-.54-.72-.72-.08-.05-.28.05-.36,0-2.56-1.67-5.72-3.48-7.74-5.76-1.03.67-2.61,0-2.7,1.8-2.65-1.83-5.66-3.37-8.1-5.04.54-.27,2.4.56,3.06.72Z"
          />

          <path
            class="cls-71"
            d="M153.39,197.31c-3.29,1.54-8.55,5.09-11.16,6.12-1.55.61-3.06,1.06-3.24-.72,2.42-1.84,5.61-2.92,7.56-5.4,2.23-.7,4.29-1.32,6.48-2.16l.36,2.16Z"
          />

          <path
            class="cls-41"
            d="M145.46,216.76l-2.16,2.52c-.9-.83-1.99-1.42-2.88-2.16-1.78-1.48-3.49-3-5.4-4.32.1-1.8,1.67-1.13,2.7-1.8,2.02,2.28,5.18,4.09,7.74,5.76Z"
          />

          <path
            class="cls-24"
            d="M122.42,201.63c.82.17,6.74,1.92,7.02,2.16.3.26-.26.7-.36.72-.49.08-8.13-1.69-9.72-1.8-2.77-.19-5.68.03-8.46,0,.73-1.43,2.26-1.95,3.24-2.88,1,1.37,2.43.04,3.78.36l-.72,1.44c1.59-.78,3.59-.33,5.22,0Z"
          />

          <path
            class="cls-71"
            d="M146.18,197.31c-3.96,1.21-10.73,4.11-14.76,3.6l14.4-6.12.36,2.52Z"
          />

          <path
            class="cls-67"
            d="M135.74,208.11c4.69,2.22,8.53,3.32,12.96,6.48,1.25.89,3.9,2.49,4.14,3.96-2.08-2.22-4.8-3.27-7.38-4.68-1.91-1.05-6.14-3.99-8.1-4.32-.24-.04-2.43.85-2.88.72-.58-.17.37-.99,0-1.08-.43-.1-.72.56-1.44.36-.92-.25-1.76-.77-3.06-1.08l5.94.72-.18-1.08Z"
          />

          <path
            class="cls-41"
            d="M140.06,217.84c.52.41,1.18.79,1.44,1.44l-1.08,1.44c-1.63-1.8-4.32-3.82-5.04-6.12,1.75,1.13,3.01,1.93,4.68,3.24Z"
          />

          <path
            class="cls-71"
            d="M143.3,219.28c1.22,1.13,2.13,2.71,3.6,3.6.17.38.47.75.72,1.08l-6.12-4.68c-.26-.65-.92-1.03-1.44-1.44l.36-.72c.89.74,1.99,1.33,2.88,2.16Z"
          />

          <path
            class="cls-5"
            d="M142.22,203.43l-2.52,1.8c-1.17-.18-2.06.41-2.88-.9.58-.73,1.44-1.08,2.16-1.62.18,1.78,1.69,1.33,3.24.72Z"
          />

          <path
            class="cls-56"
            d="M147.62,223.96c-.25-.33-.55-.71-.72-1.08s-.05-.92-.72-1.26l.9-.9c3.45-.56,18.07,22.02,16.92,27-4.98-6.68-8.65-14.32-13.5-21.06-.78-1.09-2.33-1.97-2.88-2.7Z"
          />

          <path class="cls-41" d="M146.54,217.48l-.9,1.8.18-2.52c.28.18.71.28.72.72Z" />

          <path
            class="cls-71"
            d="M77.77,173.91c1.66,1.9,9.59,9.4,10.08,10.26.07.12.34,2.21.54,2.7-1.01.14-1.58-.72-2.34-1.08-4.81-2.24-9.19-5.96-13.5-9,3.13,3.83,6.84,7.28,10.62,10.44.36.57.13,1.48-.54,1.44-.8-.05-10.66-6.54-12.06-7.56,2.41-3.25,1.7-4.03-.36-7.2,3.03-3.31,4.12-1.28,7.56,0Z"
          />

          <path
            class="cls-69"
            d="M92.54,195.87c.69.09,1.3.27,1.98.36.29-.97-.86-1.03-.9-1.08,1.01-.32,4.42-.63,3.96,1.08-.2-.01-1.57-.96-1.62,0,.98.39,2.12.64,3.06,1.08l-3.78-.72-.18,2.52c-.69-.1-3.25-.64-3.6-.18l.18,1.26c1.55-.18,1.22.24,1.98,1.08-.1.65-.98.27-1.44.36-3.74-1.26-7.81.11-11.7,0l7.92-2.88h-9.36l5.4-.72c.69-.72-2.04-1.07-2.16-1.08-1.46-.11-4.68.22-6.3.36-1.19.1-2.85.19-3.96.36-.33-.58,3.23-1.78,3.42-1.8,1.78-.23,4.71-.12,6.48.36-.22-1.81-3.37-.68-4.5-1.26,4.14-2.14,10.4.26,15.12.9Z"
          />

          <path
            class="cls-49"
            d="M75.25,169.95c4.84,4.51,7.38,6.95,12.96,10.8,1.54,1.06,3.67,3.58,5.76,3.24.46,1.32,1.79,2.26.9,3.96-3.58-2.31-2.26-.07-3.06.54-.3.23-7.16-1.3-5.76-2.7.76.36,1.33,1.23,2.34,1.08-.2-.5-.47-2.58-.54-2.7-.49-.86-8.42-8.36-10.08-10.26-1.76-2.02-3.37-4.16-5.4-5.94.95-.12,2.21,1.36,2.88,1.98Z"
          />

          <path
            class="cls-5"
            d="M77.77,166.71c3.8,2.77,8.81,10.23,11.7,12.24.76.53.79.55,1.62.36.4-.09.56-.52,1.08-.36.61,1.66,1.22,3.37,1.8,5.04-2.09.34-4.22-2.18-5.76-3.24-2.96-4.55-7.14-9.05-11.16-12.96-1.07-1.04-2.19-2-3.24-3.06,1.07.52,3.08,1.34,3.96,1.98Z"
          />

          <path
            class="cls-24"
            d="M106.58,196.23c.77,2.3.78,3.2.72,5.4-2.81-1.37-5.44-3-8.28-4.32-.94-.44-2.08-.69-3.06-1.08.05-.96,1.42-.01,1.62,0,1.2.08,6.19.93,6.48.18l-2.34-5.58,4.86,5.4Z"
          />

          <path
            class="cls-49"
            d="M89.29,170.31l-1.26.72c3.35,1.17,3.09,5.08,4.14,7.92-.52-.16-.68.27-1.08.36-1.71-5.74-6.35-9.38-10.08-13.68,1.73.88,3.15,2.33,4.86,3.24.45.24,1.12-.18,3.42,1.44Z"
          />

          <path
            class="cls-5"
            d="M90.01,192.27c1.69,1.27,2.12,1.06,3.6,2.88.04.05,1.19.11.9,1.08-.68-.09-1.29-.27-1.98-.36.27-1.02-.55-1.23-1.26-1.44-3.26-.97-6.94-.9-10.26-1.44,1.52-3.8,6.75,1.3,9-.72Z"
          />

          <path
            class="cls-68"
            d="M57.97,213.52c-.13.48-.31.95-.36,1.44-.86,0-13.07,9.71-13.32,10.8-2.61-.82-5.7,2.76-7.2,4.5-3.71,4.31-6.04,10.71-9.54,15.3.56-2.63.64-6.14,1.26-8.64.14-.58.94-3.98,1.08-4.14.52-.62,1.23.31,1.44,0,1.28-1.89,1.98-4.98,2.88-6.3,1.99-2.92,4.97-4.36,7.2-6.48l.9,3.6,16.02-11.52c-.13.46-.24,1-.36,1.44Z"
          />

          <path
            class="cls-56"
            d="M58.33,212.07l-16.02,11.52-.9-3.6c.07-.07-.08-.89.9-1.8.87-.81,6.81-4.43,5.04-5.04-1.11-.38-8.1,5.97-9.9,6.12,1.02-1.53,1.62-2.84,2.88-4.32,1.78-2.11,8.56-8.46,10.8-9.72,1.23-.69,3.76-1.47,5.22-1.8-6.12,5.92-9.4,10.19,2.52,7.56.29.39-.4.59-.54,1.08Z"
          />

          <path
            class="cls-71"
            d="M92.18,201.63c-5.17.99-11.42,3.33-14.4,7.92-.54.33-.88.81-1.44,1.08-.08-.04-.65-1.18-1.08-1.44,11.38-8.24,6.17-6.91-3.06-2.88-3.41,1.49-10.9,6.82-13.5,6.84l17.28-10.62c-.45-.73-7.46.9-8.64,1.26,1.78-3.04,7.7-2.95,10.98-3.96l-2.34-2.52c1.62-.14,4.84-.47,6.3-.36.12,0,2.85.36,2.16,1.08l-5.4.72h9.36l-7.92,2.88c3.89.11,7.96-1.26,11.7,0Z"
          />

          <path
            class="cls-41"
            d="M75.25,209.19c-3.94,2.85-8.22,5.23-12.24,7.92,1.24-1.77-2.63-.95-3.42-1.08-.49-.08-1.84-1.08-1.98-1.08.05-.49.23-.96.36-1.44.33.03.37-.36.72-.36,2.61-.02,10.09-5.35,13.5-6.84,9.23-4.03,14.44-5.36,3.06,2.88Z"
          />

          <path
            class="cls-71"
            d="M75.97,197.31l2.34,2.52c-3.28,1.01-9.2.92-10.98,3.96-4.43,1.35-10.33,5.76-14.22,6.84-.23.06-1.44.51-1.26-.18.75-2.38,20.57-10.58,19.8-11.52l-2.16-.18c.17-.03,1.78-.97,2.52-1.08,1.11-.17,2.77-.26,3.96-.36Z"
          />

          <path
            class="cls-63"
            d="M177.87,182.91c-3.06,5.61-14.87,17.53-20.88,19.44-.49.16-2.56.6-2.88.18l6.48-7.74c1.78-.9,2.77-1.91,4.32-2.88,4.23-2.65,7.01-5.27,10.8-8.28,1.02-.81,1.52-1.89,2.16-.72Z"
          />

          <path
            class="cls-41"
            d="M164.91,191.91c-1.55.97-2.54,1.98-4.32,2.88-2.13,1.07-5.18,1.57-7.2,2.52l-.36-2.16c3.58-1.38,6.72-2.83,10.08-4.68.39-.22.94-.43,1.44-.72l.36,2.16Z"
          />

          <path
            class="cls-63"
            d="M175.71,183.63c-3.79,3.02-6.57,5.63-10.8,8.28l-.36-2.16c2.05-1.19,9.3-7.09,9.9-7.2.48-.09,1.11.65,1.26,1.08Z"
          />

          <path
            class="cls-41"
            d="M146.9,242.68c4.62,4.77,9.3,9.3,14.76,13.14-.57.87-.95.36-1.62.18-2.37-.64-9.69-4.96-12.06-6.48-7.12-4.56-15.8-12.81-19.44-20.52-.32-.68-2.45-6.09-1.26-6.12l7.02,10.26c-1.91-3.43-3.48-7.02-5.04-10.62.5-.89,1.95,1.35,2.16,1.62,4.98,6.42,9.82,12.69,15.48,18.54Z"
          />

          <path
            class="cls-69"
            d="M95.06,199.11c6.74.97,2.95,2.57,3.6,3.42.4.52,1.87-.32,1.8.72l-1.8,1.08,3.24,1.8-1.8,2.7c-2.15,1.38-4.84,3.42-6.84,5.04l4.5-5.76c-2.53.89-4.51,2.42-6.66,3.96-2.96,2.12-5.2,4.52-7.92,6.84-1,.86-1.92,1.82-3.06,2.52-.74-.7,1.3-1.77,1.62-2.52l7.56-8.1c-.67-1.16-7.84,4.28-8.64,4.86-.34.24-.75.47-1.08.72-.27-.31-1.51.73-1.44-.18.06-.81,10.16-8.36,11.16-10.08.1-1.27-4.05,1.16-4.32,1.26-1.96.76-3.84,1.82-5.76,2.52-.85.31-2.03,1.11-2.88.72.56-.27.9-.75,1.44-1.08,2.85-1.75,7.53-4.08,10.62-5.4,1.23-.52,6.36-1.24,6.3-2.34-.2-.56-1.04-.5-1.08-.54-.76-.84-.44-1.26-1.98-1.08l-.18-1.26c.36-.46,2.91.08,3.6.18Z"
          />

          <path
            class="cls-56"
            d="M63.01,226.12c-.18.27-2.73,2.63-1.26,2.52,2.76-1.93,6.02-3.22,8.82-5.04-1.62,3.14-2.97,3.94-5.76,5.4-5.21,2.73-9.15,3.1-14.76,3.96l-3.06-1.8c4.93-1.98,11.15-8.3,15.66-10.08.44-.17,2.25-.72,2.52-.72,2.97.04-1.09,4.22-2.16,5.76Z"
          />

          <path
            class="cls-71"
            d="M77.77,217.84c-2.49,1.8-4.56,4.04-7.2,5.76-2.8,1.82-6.06,3.11-8.82,5.04-1.47.11,1.08-2.25,1.26-2.52-.2,1.09.77.41,1.08.18,3.97-3.02,7.82-7.22,11.88-10.26l1.8,1.8Z"
          />

          <path
            class="cls-52"
            d="M79.57,216.4c-.58.43-1.17.99-1.8,1.44l-1.8-1.8,9-8.64c.27-.1,4.42-2.53,4.32-1.26-1,1.72-11.1,9.27-11.16,10.08-.07.91,1.17-.13,1.44.18Z"
          />

          <path
            class="cls-71"
            d="M81.73,218.92c.74-1.71-.09-1.95-1.08-3.24.8-.58,7.97-6.02,8.64-4.86l-7.56,8.1Z"
          />

          <path
            class="cls-71"
            d="M91.09,212.07l-5.4,8.64c-.29.25-.63.69-1.08,1.08l-1.44-2.88c2.72-2.32,4.96-4.72,7.92-6.84Z"
          />

          <path
            class="cls-56"
            d="M63.01,217.12c-.51.34-1.23,1.54-2.16,2.16-5.08,3.38-10.7,6.1-15.84,9.36-.26-.26-.74-2.39-.72-2.52.01-.12-.03-.25,0-.36.25-1.09,12.46-10.79,13.32-10.8.14,0,1.49,1,1.98,1.08.79.13,4.66-.69,3.42,1.08Z"
          />

          <path
            class="cls-68"
            d="M60.85,219.28l1.8,1.8c-4.51,1.78-10.73,8.1-15.66,10.08l3.06,1.8c-.96.15-7.05,1.61-7.38,1.44l.36-1.08,2.7-1.62-2.52-1.26c.45-.5,1.3-1.48,1.8-1.8,5.14-3.26,10.76-5.98,15.84-9.36Z"
          />

          <path
            class="cls-68"
            d="M45.01,228.64c-.51.32-1.35,1.3-1.8,1.8l-8.28,4.86,9.36-9.18c-.02.13.46,2.26.72,2.52Z"
          />

          <path
            class="cls-14"
            d="M67.69,191.19c-.47-.12-1.66-.37-1.44-1.08.68.1,1.3.26,1.98.36l-.54.72Z"
          />

          <path
            class="cls-71"
            d="M105.86,205.59c.19,2.17-1.97,3.9-2.88,5.76-1.95-.35-.96.26-2.16,1.44-2.5,2.46-5.73,5.93-7.92,8.64-1.3,1.61-2.85,2.87-3.96,4.68-3.86,3.36-7.96,6.66-3.6-1.26,1.19-2.16,3.75-3.65,4.32-5.94,4.48-3.87,9.17-7.67,13.32-11.88,1.04-.57,1.74-1.02,2.88-1.44Z"
          />

          <path
            class="cls-41"
            d="M75.61,159.87c.9.64,1.39,1.16,2.16,1.8-3.68-.09,1.07,2.08,1.08,2.7,0,.39-2.16,1.2-1.08,2.34-.88-.64-2.89-1.46-3.96-1.98,1.05,1.06,2.17,2.02,3.24,3.06l-1.8,2.16c-.67-.62-1.93-2.1-2.88-1.98,2.03,1.78,3.64,3.92,5.4,5.94-3.44-1.28-4.53-3.31-7.56,0-1.83-2.81-8.18-9.39-10.8-11.88l.36-1.8c3.2,2.27,6.81,3.92,10.26,5.76,1.23-6.94-8.92-10.13-14.04-12.6l-6.3-1.44c-.2-.1-.53-.27-.72-.36l.72-1.08c6.38,2.07,10.15,4,16.02,6.48,1.16.49,8.52,3.62,9,3.6.78-.03.85-.69.9-.72Z"
          />

          <path
            class="cls-5"
            d="M145.82,205.95c-1.38.65-2.83,1.2-2.88-.72,1.43-.41,3.04-.43,4.5-.72.15.3-1.52,1.39-1.62,1.44Z"
          />

          <path
            class="cls-63"
            d="M43.21,151.58c3.74,4.32,7.63,8.45,11.16,12.96,1.81,2.32,3.18,5.23,5.4,7.92,5.19,6.3,10.75,11.11,17.64,15.48-4.59-1.4-9.7-2.54-14.4-5.04-.84-.45-2.1-1.69-2.88-2.16-4.23-5.26-11.59-11.14-14.04-17.46-.28-.73.03-1.54,0-1.62-1.18-2.98-1.69-6.44-3.6-9.18-.1-1.33.59-.77.72-.9Z"
          />

          <path
            class="cls-63"
            d="M45.73,151.22c4.72,3.43,9.44,6.77,13.68,10.8,2.62,2.5,8.97,9.07,10.8,11.88,2.06,3.18,2.77,3.95.36,7.2l-10.8-8.64c-2.22-2.69-3.59-5.6-5.4-7.92-.56-5.42-6.43-9.24-9.72-13.32,1.04-.33.61,0,1.08,0Z"
          />

          <path
            class="cls-56"
            d="M46.09,161.67c.03.08-.28.89,0,1.62,2.45,6.32,9.81,12.2,14.04,17.46-1.99-1.2-3.96-2.24-5.58-3.96-1.67.12,4.26,6.24,5.04,6.84.56.44,1.38.73,1.98,1.08l-.36.36c-.84-.54-2.8-1.13-3.78-1.8-1.05-.73-1.67-1.84-3.06-2.88-4.61-5.5-7.37-11.28-9.36-18.18l1.08-.54Z"
          />

          <path
            class="cls-41"
            d="M77.41,187.95c2.01.61,7.75,3.43,2.7,3.24-4.67-.17-13.69-4.41-17.46-6.48l.36-1.8c4.7,2.5,9.81,3.64,14.4,5.04Z"
          />

          <path
            class="cls-30"
            d="M60.13,180.75c.78.47,2.04,1.71,2.88,2.16l-.36,1.8c-.19-.1-.9.1-1.08,0-.6-.35-1.42-.64-1.98-1.08-.78-.6-6.71-6.72-5.04-6.84,1.63,1.72,3.59,2.76,5.58,3.96Z"
          />

          <path
            class="cls-63"
            d="M48.97,151.58c.19.09.52.26.72.36,3.96,2.09,6.83,5.97,10.08,8.28l-.36,1.8c-4.24-4.03-8.97-7.38-13.68-10.8.07,0-.39-1.02,1.26-.72.18.03,1.53.88,1.98,1.08Z"
          />

          <path
            class="cls-68"
            d="M44.65,151.22c3.29,4.08,9.16,7.9,9.72,13.32-3.53-4.52-7.42-8.64-11.16-12.96,1.3-1.31.97-.21,1.44-.36Z"
          />

          <path
            class="cls-56"
            d="M47.53,149.42c-.22-.12-.68.77-1.08.18.14-1.27,1.04-.14,1.08-.18Z"
          />

          <path
            class="cls-68"
            d="M41.41,220c-2.23,2.12-5.21,3.56-7.2,6.48-1.05-1.8,2.15-5.57,3.24-7.2,1.8-.15,8.79-6.5,9.9-6.12,1.77.61-4.17,4.23-5.04,5.04-.98.91-.83,1.73-.9,1.8Z"
          />

          <path
            class="cls-71"
            d="M77.77,161.67c.82.69,3.07,1.84,3.6,2.7.18.29-.64.93-.36,1.26,3.73,4.3,8.37,7.94,10.08,13.68-.83.19-.86.17-1.62-.36-2.89-2.01-7.9-9.48-11.7-12.24-1.08-1.14,1.09-1.95,1.08-2.34-.01-.62-4.76-2.79-1.08-2.7Z"
          />

          <path
            class="cls-5"
            d="M93.26,213.88c-2.67,2.17-4.97,4.61-7.56,6.84l5.4-8.64c2.15-1.54,4.13-3.07,6.66-3.96l-4.5,5.76Z"
          />

          <path
            class="cls-52"
            d="M109.1,212.79c-.7-.19-.89.74-1.08,1.26-1.79,4.9-3.74,11.98-5.04,17.1l-1.44-.36c.82-3.12,4.59-14.35,4.68-16.38.12-2.82-1.11-.52-1.26-.54-.11-.01-.4-1.58-1.62-.54-3.65,3.12-7.7,20.99-8.64,26.1-.26,1.43-.19,7.39-2.16,6.12.87-7.24,2.02-14.48,3.6-21.6l4.68-11.16c1.2-1.18.21-1.79,2.16-1.44.06.01.32.94.9.72.63-.24,2.64-5.58,3.6-5.04.23,1.16-.59,3.45-.18,4.5s1.48-.74,1.8,1.26Z"
          />

          <path
            class="cls-71"
            d="M111.98,234.04h-3.24c.57-4.74.86-9.26.72-14.04l2.16-2.16c.31,5.91.86,10.01.36,16.2Z"
          />

          <path
            class="cls-71"
            d="M96.14,223.96c-2.01,1.48-3.44,4.55-4.32,6.84h-1.44c.94-2.95,3.01-6.62,2.52-9.36,2.19-2.72,5.42-6.18,7.92-8.64l-4.68,11.16Z"
          />

          <path
            class="cls-41"
            d="M101.54,230.8c-.85,3.24-1.65,6.49-2.52,9.72l-4.32-1.08c.94-5.11,4.99-22.98,8.64-26.1,1.22-1.04,1.51.53,1.62.54.15.02,1.39-2.28,1.26.54-.09,2.04-3.86,13.26-4.68,16.38Z"
          />

          <path
            class="cls-49"
            d="M77.77,209.55c2.99-4.59,9.23-6.93,14.4-7.92.46-.09,1.34.29,1.44-.36.04.04.88-.02,1.08.54.06,1.1-5.07,1.82-6.3,2.34-3.09,1.32-7.77,3.65-10.62,5.4Z"
          />

          <path
            class="cls-71"
            d="M88.21,180.75c-5.58-3.85-8.12-6.29-12.96-10.8l1.8-2.16c4.02,3.91,8.2,8.41,11.16,12.96Z"
          />

          <path
            class="cls-41"
            d="M76.33,210.63c.85.39,2.03-.41,2.88-.72l-14.04,10.44c-.27,0-2.08.55-2.52.72l-1.8-1.8c.93-.62,1.65-1.82,2.16-2.16,4.02-2.69,8.31-5.07,12.24-7.92.43.26,1,1.4,1.08,1.44Z"
          />

          <path
            class="cls-41"
            d="M84.97,207.39l-9,8.64c-4.06,3.04-7.92,7.24-11.88,10.26-.31.23-1.28.91-1.08-.18,1.07-1.54,5.13-5.73,2.16-5.76l14.04-10.44c1.92-.7,3.8-1.76,5.76-2.52Z"
          />

          <g>
            <path
              class="cls-41"
              d="M107.66,149.78c-.38,2.61-.34,8.96-.36,11.88,0,1.28-.97,2.6.36,2.88-1.42.85-1.63,4.77-.36,5.76-.82.98-.93,3.18-1.8,3.24-.51-2.12-1.81-9.14-1.8-10.98.01-1.42,2.95-11.66,1.98-11.7-2.81,3.3-3.74,7.54-5.22,11.52-.04.1-1.03.28-1.44,1.44-1.89-1.88-1.44-.63-3.24-.18l.18-4.86c-2.01.58-.2,4.7-2.7,3.6.22-2.46.81-5.55,1.44-7.92,2.2,1.82,1.7-3.14,3.6-3.6-.38,2.53-.28,5.51-.36,8.1,1.3-1.6,1.41-4.1,2.16-5.94,3.74,2.28,4.32-5.19,7.56-3.24Z"
            />

            <path
              class="cls-68"
              d="M119.9,128.18c2.58,4.55,5.22,9.18,7.2,14.04l-.72.72c-1.81-5.57-5.01-10.78-8.46-15.48.47,3.79,2.2,7.36,2.7,11.16l-.72.36s-.68.12-.72-.18c-.55-4.65-1.46-9.36-4.14-13.5l-12.78,17.64c-2.58,2-3.52,4.93-3.96,7.92-1.91.47-1.4,5.42-3.6,3.6,3.43-12.84,13.25-22.97,20.52-33.67,2.33,1.94,3.26,4.87,4.68,7.38Z"
            />

            <path
              class="cls-41"
              d="M149.42,164.91c-.16.03-.71.93-2.52,1.44-5.58,1.57-8.65,2.88-12.96,6.84.68-4.59-.9-3.19-3.24-2.88-1.09.14-1-.73-2.88.72.48-4.09,2.23-8.09,2.52-12.24,2.01-.39,2.72,1.07,3.24-1.8.29,4.13-.25,8.13-.54,12.24,4.63-2.61,9.4-4.66,14.76-5.04.61-.04,1.8-.31,1.62.72Z"
            />

            <path
              class="cls-71"
              d="M99.02,163.83c-.32.89-1.22,5.57-1.08,6.3.03.15.84.72,1.08,1.26.35.78,1.05.75,1.08.9.19.85-.47,1.01-.72,1.62-.4.97-1.62,2.11-1.8,3.24-.46-1.42.06-3.44-2.52-3.78.25,1.83,1.05,5.12.18,6.66-.4-1.15-.76-2.92-1.26-3.96-.72-5.01-1.17-8.57-.72-13.68,2.5,1.1.69-3.03,2.7-3.6l-.18,4.86c1.8-.45,1.35-1.7,3.24.18Z"
            />

            <path
              class="cls-63"
              d="M133.58,156.99c-.52,2.87-1.23,1.41-3.24,1.8.48-7.04-.69-10.29-3.24-16.56-1.98-4.86-4.62-9.5-7.2-14.04,1.39.38,3.15,2.98,3.96,4.14,5.27,7.54,9.07,15.37,9.72,24.66Z"
            />

            <path
              class="cls-16"
              d="M131.42,178.59c0,.67,1.34.88,1.44,1.08.78,1.56-2.56,2.55-3.6,3.78-.13.15-.8,2.33-1.8,3.42s-1.68.66-1.8.72c-.3-.22-1.75-1.34-1.8-1.44-.1-.2-.75-3.6-.72-3.96.25-3.28,2.69-2.83,5.04-1.8.06.03.69,1.12.9,1.08.18-.03,2.17-2.62,2.34-2.88Z"
            />

            <path
              class="cls-31"
              d="M133.94,173.19c-.03.21-1.35,3.77-1.44,3.96-.39.78-.79,1.01-1.08,1.44-.18.26-2.16,2.85-2.34,2.88-.21.04-.84-1.05-.9-1.08l2.88-8.64c.08-.66-.47-.81-.36-1.44,2.34-.31,3.92-1.71,3.24,2.88Z"
            />

            <path
              class="cls-66"
              d="M115.58,191.55c.3-.05.36.35.72.36.23,0,.5-.04.72,0,2.41.48,3.9-.23,2.16,2.52-.89,1.4-1.75,1.45-2.52,2.16-2.07,1.91-4.8,3.53-6.12,6.12-1.28-.05-.65-.36-.72-.36,1.73-2.03,2.97-10.35,5.76-10.8Z"
            />

            <path
              class="cls-63"
              d="M114.14,199.83c-.98.93-2.51,1.45-3.24,2.88-.12,0-.24,0-.36,0,1.32-2.59,4.05-4.21,6.12-6.12-.36,1.07-1.72,2.48-2.52,3.24Z"
            />

            <path
              class="cls-71"
              d="M120.62,138.62c1.25,9.51-.65,16.32-2.52,25.38-.22,1.08-1.79,3.74-1.8,3.96,0,.13.8,1.11,1.08,2.34-.92.28-.17.76,0,1.08.02.04.56,0,.36.72-.9-.04-1.16.21-1.8.72-.58.47-1.39.89-.36,2.16-.19,1.09-.45,2.99-.72,3.96l-1.26,1.44-.9-.9c2.31-.8.26-2.52.54-4.14-1.49-.59-.58,4.59-1.08,5.04-.55-8.34-5.88-4.18-4.5,1.98h3.24l-1.08,11.52c-.85.52-.68-.14-.72-.72-.18-2.63,1.38-6.36.54-9.18l-1.26,9.72c-.17-.86-.95-1.9-1.08-2.52,1.61-1.72,1.2-6.13.36-8.1-.36-.84-.55-1.19-1.44-.54-.84-3.84-4.4-4.24-5.76-.72-.02-.12-.71-1.16-.36-1.8,2.55,0,5.4-3.11,3.24-5.76.22.11.51-.38.54-.36.64.46,2.55,3.76,2.88,3.6l-1.26-3.96c.87-.06.98-2.26,1.8-3.24,1.14.89,1.56-.68,1.8-.18-.03,2.71-2.53,4.14-1.62,6.66,1.18-.46,1.93-4.22,2.16-4.32,2.35-.99-.26,1.95.36,2.52.89-2.14,3.07-1.34,3.24-1.44,3.94-2.3,1.01-3.97,1.62-5.94.14-.47,1.34-.64,1.44-1.08.54-2.3.69-4.69-.72-6.66,1.42-1.27,4.18-12.76,4.32-15.12.1-1.65.16-4.15,0-5.76l.72-.36Z"
            />

            <path
              class="cls-16"
              d="M103.34,174.27c2.16,2.65-.69,5.77-3.24,5.76-2.18,0-2.15-1.76-2.52-2.88.18-1.13,1.4-2.27,1.8-3.24,2.34-.76,2.05-.59,3.96.36Z"
            />

            <path
              class="cls-16"
              d="M106.22,182.55c.05.22-.04.5,0,.72-.53.46-1.84,1.67-2.16,2.16-.35.54.3,1.39-.18,1.44-.13.01-.65-1.59-.9-1.8-2.22-1.91-1.95.77-2.52-3.24,1.36-3.52,4.92-3.12,5.76.72Z"
            />

            <path
              class="cls-41"
              d="M119.9,144.74c-.14,2.36-2.9,13.85-4.32,15.12-.07.06-1.75.63-1.8.54,1.79-6.54-6.13.69-.72,3.24l-3.42,5.58c-.34-.11,2.04-7.1-1.98-4.68-1.33-.29-.37-1.6-.36-2.88,1.12-2.68,1.46-5.77,2.52-8.46,1.13-2.86,5.1-8.2,5.76-10.26,1.45,1.14,3.74-.05,4.32,1.8Z"
            />

            <path
              class="cls-44"
              d="M115.58,159.87c1.41,1.97,1.26,4.36.72,6.66-.1.44-1.3.61-1.44,1.08-.61,1.98,2.32,3.65-1.62,5.94-.17.1-2.35-.7-3.24,1.44-.62-.57,1.99-3.51-.36-2.52-.23.1-.98,3.86-2.16,4.32-.91-2.53,1.59-3.95,1.62-6.66-.24-.5-.66,1.07-1.8.18-1.27-.99-1.06-4.91.36-5.76,4.02-2.41,1.64,4.57,1.98,4.68l3.42-5.58c-5.41-2.56,2.51-9.78.72-3.24.05.09,1.73-.48,1.8-.54Z"
            />

            <path
              class="cls-71"
              d="M105.5,173.55l1.26,3.96c-.33.16-2.24-3.14-2.88-3.6-.03-.02-.32.47-.54.36-1.91-.95-1.62-1.12-3.96-.36.25-.61.91-.77.72-1.62-.03-.15-.73-.12-1.08-.9,3.16-1.23,6.16-8.06,1.44-9,1.48-3.98,2.41-8.23,5.22-11.52.97.04-1.97,10.28-1.98,11.7-.01,1.85,1.29,8.86,1.8,10.98Z"
            />

            <path
              class="cls-63"
              d="M115.58,142.94c-.66,2.06-4.63,7.41-5.76,10.26-1.06,2.69-1.4,5.79-2.52,8.46.02-2.93-.02-9.27.36-11.88.18-1.21,1.22-3.89,1.8-5.04,1.38-2.73,3.58-6.41,6.48-3.06-.15.4-.24.87-.36,1.26Z"
            />

            <path
              class="cls-63"
              d="M106.94,142.22c-2.26,3.87-4.81,5.8-6.84,10.8-.75,1.84-.86,4.34-2.16,5.94.08-2.59-.02-5.57.36-8.1.44-2.99,1.38-5.92,3.96-7.92.67-.52,4.94-2.66,5.4-1.98-.67.28-.58,1.02-.72,1.26Z"
            />

            <path
              class="cls-41"
              d="M109.46,144.74c-.58,1.15-1.63,3.83-1.8,5.04-3.24-1.95-3.82,5.52-7.56,3.24,2.03-5,4.58-6.93,6.84-10.8-.27,1.21,1.54,2.18,2.52,2.52Z"
            />

            <path
              class="cls-44"
              d="M99.02,171.39c-.24-.54-1.05-1.11-1.08-1.26-.14-.74.76-5.41,1.08-6.3.41-1.16,1.4-1.34,1.44-1.44,4.72.94,1.72,7.78-1.44,9Z"
            />

            <path
              class="cls-30"
              d="M126.38,142.94c1.29,3.98,2.15,6.46,2.16,10.8-2.06.7-4.31,8.65-4.32,10.44-3.14-.46-7.85,2.79-3.96,5.04l-1.44,2.88c-.27-.07-.73.01-1.08,0,.2-.72-.34-.68-.36-.72.75-.83.01-1.03,0-1.08-.28-1.24-1.09-2.21-1.08-2.34,0-.22,1.58-2.88,1.8-3.96,1.87-9.06,3.77-15.87,2.52-25.38-.5-3.8-2.23-7.37-2.7-11.16,3.45,4.7,6.66,9.91,8.46,15.48Z"
            />

            <path
              class="cls-63"
              d="M119.9,138.98c.16,1.61.1,4.11,0,5.76-.58-1.85-2.87-.66-4.32-1.8.12-.39.21-.86.36-1.26-2.9-3.35-5.1.33-6.48,3.06-.98-.34-2.79-1.31-2.52-2.52.14-.24.06-.98.72-1.26-.46-.68-4.73,1.46-5.4,1.98l12.78-17.64c2.68,4.14,3.59,8.86,4.14,13.5.04.3.72.14.72.18Z"
            />

            <path
              class="cls-41"
              d="M130.34,158.79c-.87.17-1.18,1.14-2.52.72.38-2.04.73-3.64.72-5.76-.01-4.34-.87-6.82-2.16-10.8l.72-.72c2.56,6.27,3.73,9.52,3.24,16.56Z"
            />

            <path
              class="cls-71"
              d="M130.34,158.79c-.29,4.15-2.05,8.15-2.52,12.24-1.07.83-4.64,6.03-2.7,6.48,2.4.52,5.71-3.91,5.94-5.76l-2.88,8.64c-2.35-1.03-4.79-1.48-5.04,1.8-1.29-.05-2.48,1.25-1.8-.72,2.15-1.55,2.42-1.99,2.16-4.14-.7-1.28-3.31,1.69-3.6,2.34l-.72-.36c-.09-1.45.25-2.44.72-3.78.13-.37,1.61,1.04.36-1.62-.28-.6.08-.42-.72-1.08-.11-.09-.67-.71-.72-.72l1.44-2.88c2.61,1.51,3.75.96,5.04-1.44.98-1.81,2.13-6.16,2.52-8.28,1.35.42,1.65-.55,2.52-.72Z"
            />

            <path
              class="cls-16"
              d="M130.7,170.31c-.11.63.44.78.36,1.44-.23,1.85-3.54,6.28-5.94,5.76-1.94-.45,1.63-5.66,2.7-6.48,1.88-1.45,1.79-.58,2.88-.72Z"
            />

            <path
              class="cls-5"
              d="M120.62,181.47c.09-.07.62.07.72,0-.68,1.97.51.67,1.8.72-.03.36.62,3.76.72,3.96l-1.62,1.8c2.57,1.51,2.76-.04,3.42-.36.12-.06.76.41,1.8-.72l1.08.36c-1.01.58-2.4,1.83-3.24,2.16-1.94.77-1.26-.25-3.06.36.6-2.29-2.14.81-3.78-.36.94-1.78,2.51-3.79-.36-2.7,1.11-3.18,1.68-1.32,2.52-1.62,2.05-.73,2.8-2.66-.72-1.44-2.44.84-2.19,2.71-4.68,4.14,1.27-1.21,2.47-4.38,3.6-5.4.94-.85,1.71-.83,1.8-.9Z"
            />

            <path
              class="cls-16"
              d="M125.3,189.39c-.9,3.51-2.94,4.1-6.12,5.04,1.74-2.75.25-2.04-2.16-2.52.47-.86.98-1.64,1.44-2.52,1.64,1.17,4.38-1.93,3.78.36,1.8-.61,1.12.41,3.06-.36Z"
            />

            <path
              class="cls-86"
              d="M125.66,187.59c-.66.32-.85,1.87-3.42.36l1.62-1.8c.05.1,1.5,1.22,1.8,1.44Z"
            />

            <path
              class="cls-44"
              d="M114.86,178.95c-.32,1.18-1.76,3.2-1.8,3.42-.63,3.07-.95,15.64-2.88,17.64-.47.45-.66.23-.72-.36-.05-.5,2.3-7.98,2.52-9.72.37-2.9.56-5.9.18-8.82l-3.42,19.26c-.75-1.26-1.11-2.72-1.44-4.14,1.62.34,1.41-.82,1.08-2.52l1.26-9.72c.84,2.82-.72,6.55-.54,9.18.04.58-.13,1.24.72.72l1.08-11.52h-3.24c-1.38-6.16,3.95-10.32,4.5-1.98.5-.45-.41-5.63,1.08-5.04-.28,1.62,1.77,3.34-.54,4.14l.9.9,1.26-1.44Z"
            />

            <path
              class="cls-69"
              d="M107.3,191.19c.13.62.91,1.66,1.08,2.52.33,1.7.54,2.86-1.08,2.52-.84-3.59-.6-7.88-3.24-10.8.32-.49,1.63-1.7,2.16-2.16.49,2.51.52,5.17,1.08,7.92Z"
            />

            <path
              class="cls-44"
              d="M121.34,181.47c-.1.07-.63-.07-.72,0-.41-.39-.72-.61-1.08-1.08.56.02.27-.52.36-.72.29-.65,2.9-3.62,3.6-2.34.26,2.15-.01,2.59-2.16,4.14Z"
            />

            <path class="cls-16" d="M120.62,185.07l-.72-1.44c3.52-1.22,2.77.71.72,1.44Z" />

            <g>
              <path
                class="cls-30"
                d="M117.74,172.11c.35.01.81-.07,1.08,0,.05.01.61.63.72.72.04.32-.76.85-.72.9.28.37,1.04.11,1.44.18,1.25,2.66-.23,1.25-.36,1.62-.47,1.34-.81,2.33-.72,3.78.05.83-.55-.09.36,1.08.36.47.67.69,1.08,1.08-.09.07-.86.05-1.8.9-1.13,1.02-2.33,4.19-3.6,5.4,2.5-1.43,2.24-3.3,4.68-4.14l.72,1.44c-.84.3-1.41-1.56-2.52,1.62,2.87-1.09,1.3.92.36,2.7-.46.88-.97,1.66-1.44,2.52-.22-.04-.49,0-.72,0,.2-.66-.47-1.15-.72-.36-2.79.45-4.04,8.77-5.76,10.8-.31-.02-1.77.72-2.52.36,0-.05,0-.74,0-1.08.06-2.2.05-3.1-.72-5.4l-3.6-11.16c.25.21.77,1.81.9,1.8.48-.05-.17-.9.18-1.44,2.64,2.93,2.4,7.22,3.24,10.8.33,1.42.69,2.88,1.44,4.14l3.42-19.26c.38,2.92.19,5.92-.18,8.82-.22,1.74-2.57,9.22-2.52,9.72.06.59.25.81.72.36,1.93-2,2.25-14.57,2.88-17.64.05-.22,1.48-2.24,1.8-3.42.27-.97.53-2.87.72-3.96.12-.7.06-1.45.36-2.16.64-.51.9-.76,1.8-.72Z"
              />

              <g>
                <path
                  class="cls-49"
                  d="M114.5,186.51h-.36c-1.28-.67,0-3.66.9-3.6.38.22-.4,3.01-.54,3.6Z"
                />

                <path
                  class="cls-13"
                  d="M115.76,178.59c.23-.17,2.08-.11,2.34.54-1.23-.33-2.22,1.69-2.34,1.62-.29-.17-.3-1.95,0-2.16Z"
                />

                <path
                  class="cls-7"
                  d="M114.14,186.51h.36c-.17.75.2,1.73-.54,2.52-.35-.78-.88-2.65.18-2.52Z"
                />

                <path
                  class="cls-13"
                  d="M115.94,172.83c-.3.71-.24,1.46-.36,2.16-1.03-1.27-.22-1.69.36-2.16Z"
                />

                <path
                  class="cls-16"
                  d="M120.26,173.91c-.4-.07-1.16.19-1.44-.18-.04-.05.77-.58.72-.9.8.66.44.48.72,1.08Z"
                />

                <path
                  class="cls-79"
                  d="M119.9,179.67c-.09.2.2.74-.36.72-.91-1.17-.31-.25-.36-1.08l.72.36Z"
                />

                <path
                  class="cls-49"
                  d="M116.3,191.91c-.36-.01-.42-.41-.72-.36.25-.79.92-.3.72.36Z"
                />
              </g>
            </g>

            <path
              class="cls-5"
              d="M107.3,191.19c-.56-2.75-.59-5.41-1.08-7.92-.04-.22.05-.5,0-.72.89-.65,1.08-.3,1.44.54.84,1.97,1.25,6.38-.36,8.1Z"
            />

            <path class="cls-13" d="M117.38,171.39c-.17-.32-.92-.8,0-1.08.01.05.75.25,0,1.08Z" />

            <path
              class="cls-16"
              d="M124.22,164.19c0,.49,1.33,2.83,1.08,3.6-1.29,2.4-2.43,2.95-5.04,1.44-3.89-2.25.82-5.5,3.96-5.04Z"
            />

            <path
              class="cls-30"
              d="M128.54,153.75c0,2.12-.34,3.72-.72,5.76s-1.54,6.47-2.52,8.28c.25-.77-1.08-3.11-1.08-3.6.01-1.79,2.26-9.74,4.32-10.44Z"
            />
          </g>

          <path
            class="cls-56"
            d="M59.77,160.23c-3.25-2.31-6.12-6.19-10.08-8.28l6.3,1.44c5.12,2.47,15.27,5.66,14.04,12.6-3.45-1.84-7.07-3.49-10.26-5.76Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style>
.cls-1 {
  fill: #06548f;
}

.cls-2 {
  fill: #f7d3d7;
}

.cls-3 {
  fill: #ede2e8;
}

.cls-4 {
  fill: #474c73;
}

.cls-5 {
  fill: #fabf32;
}

.cls-6 {
  fill: #db7099;
}

.cls-7 {
  fill: #bb5c2a;
}

.cls-8 {
  fill: #79a027;
}

.cls-9 {
  fill: #7c518a;
}

.cls-10 {
  fill: #159ba0;
}

.cls-11 {
  fill: #1b69a9;
}

.cls-12 {
  fill: #b7ae2e;
}

.cls-13 {
  fill: #de7f48;
}

.cls-14 {
  fill: #d5c89a;
}

.cls-15 {
  fill: #b9d425;
}

.cls-16 {
  fill: #ad6840;
}

.cls-17 {
  fill: #556267;
}

.cls-18 {
  fill: #257844;
}

.cls-19 {
  fill: #d3c9b9;
}

.cls-20 {
  fill: #ad93b5;
}

.cls-21 {
  fill: #b8a786;
}

.cls-22 {
  fill: #035e6f;
}

.cls-23 {
  fill: #88d5c1;
}

.cls-24 {
  fill: #cf3c21;
}

.cls-25 {
  fill: #14121e;
}

.cls-26 {
  fill: #02888b;
}

.cls-27 {
  fill: #0181a1;
}

.cls-28 {
  fill: #c9778d;
}

.cls-29 {
  fill: #c0adbc;
}

.cls-30 {
  fill: #f1e7bc;
}

.cls-31 {
  fill: #d89654;
}

.cls-32 {
  fill: #87597c;
}

.cls-33 {
  fill: #b24a60;
}

.cls-34 {
  fill: #aa1a50;
}

.cls-35 {
  fill: #9fbf29;
}

.cls-36 {
  fill: #6eb273;
}

.cls-37 {
  fill: #e09aa9;
}

.cls-38 {
  fill: #4f7012;
}

.cls-39 {
  fill: #9fa5a4;
}

.cls-40 {
  fill: #f1b7c2;
}

.cls-41 {
  fill: #e6da96;
}

.cls-42 {
  fill: #96cfb0;
}

.cls-43 {
  fill: #9b8e69;
}

.cls-44 {
  fill: #b97a47;
}

.cls-45 {
  fill: #77564d;
}

.cls-46 {
  fill: #27154b;
}

.cls-47 {
  fill: #a25e96;
}

.cls-48 {
  fill: #c32571;
}

.cls-49 {
  fill: #f8a92a;
}

.cls-50 {
  fill: #14b4c1;
}

.cls-51 {
  fill: #a873a8;
}

.cls-52 {
  fill: #f5d141;
}

.cls-53 {
  fill: #fa6914;
}

.cls-54 {
  fill: #016288;
}

.cls-55 {
  fill: #52a87b;
}

.cls-56 {
  fill: #fff;
}

.cls-57 {
  fill: #7d555e;
}

.cls-58 {
  fill: #99c993;
}

.cls-59 {
  fill: #6f8929;
}

.cls-60 {
  fill: #2a958b;
}

.cls-61 {
  fill: #6e737f;
}

.cls-62 {
  fill: #a99a8a;
}

.cls-63 {
  fill: #e9e4d3;
}

.cls-64 {
  fill: #5e5071;
}

.cls-65 {
  fill: #532e5d;
}

.cls-66 {
  fill: #b14a43;
}

.cls-67 {
  fill: #f49c30;
}

.cls-68 {
  fill: #e0dedf;
}

.cls-69 {
  fill: #fd871c;
}

.cls-70 {
  fill: #b584af;
}

.cls-71 {
  fill: #e7d672;
}

.cls-72 {
  fill: #2b2550;
}

.cls-73 {
  fill: #d4adab;
}

.cls-74 {
  fill: #c8cb40;
}

.cls-75 {
  fill: url(#Unbenannter_Verlauf_14);
}

.cls-76 {
  fill: #bc9b9d;
}

.cls-77 {
  fill: #4dbda4;
}

.cls-78 {
  fill: #dbc4d3;
}

.cls-79 {
  fill: #6c1d23;
}

.cls-80 {
  fill: #bc6675;
}

.cls-81 {
  fill: #028899;
}

.cls-82 {
  fill: #caa6be;
}

.cls-83 {
  fill: #a4103a;
}

.cls-84 {
  fill: #cac1c3;
}

.cls-85 {
  fill: #30a389;
}

.cls-86 {
  fill: #efcd7a;
}

.cls-87 {
  fill: #96b254;
}

.cls-88 {
  fill: #cacad3;
}

.cls-89 {
  fill: #cdb0a5;
}
</style>
